module.exports = {
	"Hamilton, Bermuda": {
		"slug": "",
		"currency_type": "BMD",
		"index": 128.19,
		"rent_index": 113.35,
		"groceries_index": 131.79,
		"restaurant_index": 151.38,
		"purchasing_index": 96.54
	},
	"Geneva, Switzerland": {
		"slug": "geneva",
		"currency_type": "CHF",
		"index": 103.02,
		"rent_index": 70.66,
		"groceries_index": 129.84,
		"restaurant_index": 131.7,
		"purchasing_index": 121.11
	},
	"Basel, Switzerland": {
		"slug": "",
		"currency_type": "CHF",
		"index": 92.5,
		"rent_index": 51.14,
		"groceries_index": 135.74,
		"restaurant_index": 120.52,
		"purchasing_index": 102.2
	},
	"Zurich, Switzerland": {
		"slug": "zurich",
		"currency_type": "CHF",
		"index": 98.72,
		"rent_index": 64.69,
		"groceries_index": 131.73,
		"restaurant_index": 131.71,
		"purchasing_index": 134.5
	},
	"Zug, Switzerland": {
		"slug": "",
		"currency_type": "CHF",
		"index": 96.13,
		"rent_index": 66.03,
		"groceries_index": 126.15,
		"restaurant_index": 118.38,
		"purchasing_index": 96.22
	},
	"Lausanne, Switzerland": {
		"slug": "Lausanne",
		"currency_type": "CHF",
		"index": 87.6,
		"rent_index": 54.82,
		"groceries_index": 115,
		"restaurant_index": 119.34,
		"purchasing_index": 117.56
	},
	"Bern, Switzerland": {
		"slug": "bern",
		"currency_type": "CHF",
		"index": 82.75,
		"rent_index": 45.14,
		"groceries_index": 116.79,
		"restaurant_index": 113.61,
		"purchasing_index": 100.69
	},
	"Lugano, Switzerland": {
		"slug": "",
		"currency_type": "CHF",
		"index": 84.54,
		"rent_index": 51.44,
		"groceries_index": 104.96,
		"restaurant_index": 121.17,
		"purchasing_index": 92.46
	},
	"Stavanger, Norway": {
		"slug": "",
		"currency_type": "NOK",
		"index": 76.08,
		"rent_index": 36.73,
		"groceries_index": 102.26,
		"restaurant_index": 134.69,
		"purchasing_index": 111.35
	},
	"Trondheim, Norway": {
		"slug": "",
		"currency_type": "NOK",
		"index": 78.1,
		"rent_index": 41.6,
		"groceries_index": 102.06,
		"restaurant_index": 118.57,
		"purchasing_index": 98.92
	},
	"Reykjavik, Iceland": {
		"slug": "reykjavik",
		"currency_type": "ISK",
		"index": 81.95,
		"rent_index": 49.73,
		"groceries_index": 104.22,
		"restaurant_index": 120.42,
		"purchasing_index": 77.42
	},
	"Venice, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 70.43,
		"rent_index": 27.61,
		"groceries_index": 84.39,
		"restaurant_index": 131.18,
		"purchasing_index": 50.53
	},
	"Oslo, Norway": {
		"slug": "oslo",
		"currency_type": "NOK",
		"index": 77.7,
		"rent_index": 45.94,
		"groceries_index": 98.05,
		"restaurant_index": 119.36,
		"purchasing_index": 101.49
	},
	"Bergen, Norway": {
		"slug": "bergen",
		"currency_type": "NOK",
		"index": 74.49,
		"rent_index": 41.99,
		"groceries_index": 96.72,
		"restaurant_index": 107.09,
		"purchasing_index": 101.42
	},
	"Nassau, Bahamas": {
		"slug": "",
		"currency_type": "BSD",
		"index": 72.9,
		"rent_index": 40.03,
		"groceries_index": 96.25,
		"restaurant_index": 91.5,
		"purchasing_index": 40.42
	},
	"New York, NY, United States": {
		"slug": "new-york",
		"currency_type": "USD",
		"index": 100,
		"rent_index": 100,
		"groceries_index": 100,
		"restaurant_index": 100,
		"purchasing_index": 100
	},
	"Honolulu, HI, United States": {
		"slug": "honolulu",
		"currency_type": "USD",
		"index": 84.08,
		"rent_index": 67.28,
		"groceries_index": 106.51,
		"restaurant_index": 87.51,
		"purchasing_index": 85.56
	},
	"San Francisco, CA, United States": {
		"slug": "san-francisco-bay-area",
		"currency_type": "USD",
		"index": 111.92,
		"rent_index": 125.79,
		"groceries_index": 110.16,
		"restaurant_index": 91.99,
		"purchasing_index": 96.76
	},
	"Anchorage, AK, United States": {
		"slug": "anchorage",
		"currency_type": "USD",
		"index": 72.71,
		"rent_index": 44.49,
		"groceries_index": 99.8,
		"restaurant_index": 84.06,
		"purchasing_index": 136.45
	},
	"Washington, DC, United States": {
		"slug": "washington-dc",
		"currency_type": "USD",
		"index": 88.32,
		"rent_index": 80.69,
		"groceries_index": 91.28,
		"restaurant_index": 89.65,
		"purchasing_index": 110.15
	},
	"New Haven, CT, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 72,
		"rent_index": 48.36,
		"groceries_index": 108.07,
		"restaurant_index": 94.52,
		"purchasing_index": 121.84
	},
	"Berkeley, CA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 85.02,
		"rent_index": 77.68,
		"groceries_index": 102.21,
		"restaurant_index": 78.8,
		"purchasing_index": 99.25
	},
	"Santa Cruz, CA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 81.01,
		"rent_index": 69.34,
		"groceries_index": 102.62,
		"restaurant_index": 73.04,
		"purchasing_index": 121.28
	},
	"Kuwait City, Kuwait": {
		"slug": "",
		"currency_type": "KWD",
		"index": 66.31,
		"rent_index": 39.06,
		"groceries_index": 107.55,
		"restaurant_index": 52.7,
		"purchasing_index": 76.99
	},
	"Brooklyn, NY, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 85.49,
		"rent_index": 79.24,
		"groceries_index": 86.17,
		"restaurant_index": 104.31,
		"purchasing_index": 96.19
	},
	"Tokyo, Japan": {
		"slug": "tokyo",
		"currency_type": "JPY",
		"index": 67.43,
		"rent_index": 41.86,
		"groceries_index": 94.79,
		"restaurant_index": 55.87,
		"purchasing_index": 98.6
	},
	"Seattle, WA, United States": {
		"slug": "seattle",
		"currency_type": "USD",
		"index": 78.67,
		"rent_index": 65.77,
		"groceries_index": 93.9,
		"restaurant_index": 79.85,
		"purchasing_index": 119.76
	},
	"Arlington, VA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 80.46,
		"rent_index": 70.62,
		"groceries_index": 84.67,
		"restaurant_index": 87.73,
		"purchasing_index": 127.26
	},
	"Florence, Italy": {
		"slug": "florence",
		"currency_type": "EUR",
		"index": 59.25,
		"rent_index": 26.45,
		"groceries_index": 80.87,
		"restaurant_index": 80.49,
		"purchasing_index": 53.78
	},
	"Boston, MA, United States": {
		"slug": "boston",
		"currency_type": "USD",
		"index": 83.7,
		"rent_index": 77.51,
		"groceries_index": 90.68,
		"restaurant_index": 90.96,
		"purchasing_index": 131.75
	},
	"Akron, OH, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 57.05,
		"rent_index": 22.83,
		"groceries_index": 99.03,
		"restaurant_index": 69.28,
		"purchasing_index": 74.48
	},
	"Oakland, CA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 85.96,
		"rent_index": 83.51,
		"groceries_index": 91.72,
		"restaurant_index": 87.79,
		"purchasing_index": 88.89
	},
	"Copenhagen, Denmark": {
		"slug": "copenhagen",
		"currency_type": "DKK",
		"index": 67.68,
		"rent_index": 45.64,
		"groceries_index": 68.02,
		"restaurant_index": 104.57,
		"purchasing_index": 102.15
	},
	"Dusseldorf, Germany": {
		"slug": "dusseldorf",
		"currency_type": "EUR",
		"index": 62.34,
		"rent_index": 34.99,
		"groceries_index": 74.4,
		"restaurant_index": 85.86,
		"purchasing_index": 102.46
	},
	"Santa Rosa, CA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 71.32,
		"rent_index": 54.64,
		"groceries_index": 86.35,
		"restaurant_index": 77.61,
		"purchasing_index": 105.42
	},
	"Charleston, SC, United States": {
		"slug": "charleston",
		"currency_type": "USD",
		"index": 69.4,
		"rent_index": 50.82,
		"groceries_index": 95.5,
		"restaurant_index": 82.25,
		"purchasing_index": 128.01
	},
	"Limerick, Ireland": {
		"slug": "",
		"currency_type": "EUR",
		"index": 55.19,
		"rent_index": 21.17,
		"groceries_index": 83.88,
		"restaurant_index": 78.52,
		"purchasing_index": 98.49
	},
	"Philadelphia, PA, United States": {
		"slug": "philadelphia",
		"currency_type": "USD",
		"index": 69.59,
		"rent_index": 51.39,
		"groceries_index": 89.52,
		"restaurant_index": 76.21,
		"purchasing_index": 129.65
	},
	"Miami, FL, United States": {
		"slug": "miami",
		"currency_type": "USD",
		"index": 75.25,
		"rent_index": 63.33,
		"groceries_index": 84.65,
		"restaurant_index": 89.37,
		"purchasing_index": 90.43
	},
	"Allentown, PA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 61.32,
		"rent_index": 34.41,
		"groceries_index": 91.49,
		"restaurant_index": 70.89,
		"purchasing_index": 76.93
	},
	"Sydney, Australia": {
		"slug": "sydney",
		"currency_type": "AUD",
		"index": 75.82,
		"rent_index": 64.72,
		"groceries_index": 79.21,
		"restaurant_index": 71.93,
		"purchasing_index": 109.23
	},
	"Perth, Australia": {
		"slug": "perth",
		"currency_type": "AUD",
		"index": 64.24,
		"rent_index": 40.89,
		"groceries_index": 80.31,
		"restaurant_index": 88.93,
		"purchasing_index": 113.65
	},
	"Modena, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 53.17,
		"rent_index": 18.23,
		"groceries_index": 72.38,
		"restaurant_index": 74.14,
		"purchasing_index": 60.64
	},
	"Darwin, Australia": {
		"slug": "",
		"currency_type": "AUD",
		"index": 66.27,
		"rent_index": 46.23,
		"groceries_index": 85.94,
		"restaurant_index": 81.22,
		"purchasing_index": 71.75
	},
	"Burlington, VT, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 64.23,
		"rent_index": 42.05,
		"groceries_index": 92.56,
		"restaurant_index": 75.33,
		"purchasing_index": 115.38
	},
	"Padova, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 54.5,
		"rent_index": 21.79,
		"groceries_index": 71.84,
		"restaurant_index": 75.41,
		"purchasing_index": 67.01
	},
	"Chicago, IL, United States": {
		"slug": "chicago",
		"currency_type": "USD",
		"index": 72.13,
		"rent_index": 58.68,
		"groceries_index": 80.88,
		"restaurant_index": 82.58,
		"purchasing_index": 122.99
	},
	"Fairfax, VA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 71.42,
		"rent_index": 57.46,
		"groceries_index": 81.69,
		"restaurant_index": 73.65,
		"purchasing_index": 140.52
	},
	"Hamilton, New Zealand": {
		"slug": "",
		"currency_type": "NZD",
		"index": 55.6,
		"rent_index": 24.7,
		"groceries_index": 69.86,
		"restaurant_index": 80.85,
		"purchasing_index": 123.08
	},
	"Leuven, Belgium": {
		"slug": "",
		"currency_type": "EUR",
		"index": 55.8,
		"rent_index": 25.21,
		"groceries_index": 90.57,
		"restaurant_index": 70.99,
		"purchasing_index": 82.57
	},
	"Auckland, New Zealand": {
		"slug": "auckland",
		"currency_type": "NZD",
		"index": 64.91,
		"rent_index": 44.27,
		"groceries_index": 76.97,
		"restaurant_index": 76.44,
		"purchasing_index": 102.2
	},
	"Melbourne, FL, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 57.63,
		"rent_index": 29.36,
		"groceries_index": 92.94,
		"restaurant_index": 81.45,
		"purchasing_index": 131.77
	},
	"Stockholm, Sweden": {
		"slug": "stockholm",
		"currency_type": "SEK",
		"index": 62.79,
		"rent_index": 40.37,
		"groceries_index": 77.33,
		"restaurant_index": 84.52,
		"purchasing_index": 101.95
	},
	"Paris, France": {
		"slug": "paris",
		"currency_type": "EUR",
		"index": 63.76,
		"rent_index": 42.64,
		"groceries_index": 79.61,
		"restaurant_index": 80.89,
		"purchasing_index": 95.4
	},
	"St. John's, NL, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 53.89,
		"rent_index": 22.22,
		"groceries_index": 90.7,
		"restaurant_index": 78.89,
		"purchasing_index": 90.24
	},
	"Pittsburgh, PA, United States": {
		"slug": "pittsburgh",
		"currency_type": "USD",
		"index": 61.77,
		"rent_index": 38.74,
		"groceries_index": 84.26,
		"restaurant_index": 75.85,
		"purchasing_index": 146.69
	},
	"Minneapolis, MN, United States": {
		"slug": "minneapolis-saint-paul",
		"currency_type": "USD",
		"index": 62.91,
		"rent_index": 41.16,
		"groceries_index": 90.3,
		"restaurant_index": 73.62,
		"purchasing_index": 119.76
	},
	"Irvine, CA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 75.53,
		"rent_index": 67.51,
		"groceries_index": 86.93,
		"restaurant_index": 76.12,
		"purchasing_index": 128.29
	},
	"San Jose, CA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 83.99,
		"rent_index": 85.35,
		"groceries_index": 84.96,
		"restaurant_index": 79.15,
		"purchasing_index": 152.9
	},
	"Boulder, CO, United States": {
		"slug": "boulder",
		"currency_type": "USD",
		"index": 70.17,
		"rent_index": 56.56,
		"groceries_index": 80.17,
		"restaurant_index": 80.82,
		"purchasing_index": 131.14
	},
	"Portland, ME, United States": {
		"slug": "portland-me",
		"currency_type": "USD",
		"index": 62.57,
		"rent_index": 40.81,
		"groceries_index": 83.13,
		"restaurant_index": 90.33,
		"purchasing_index": 104.14
	},
	"Denver, CO, United States": {
		"slug": "denver",
		"currency_type": "USD",
		"index": 69.22,
		"rent_index": 54.68,
		"groceries_index": 82.51,
		"restaurant_index": 74.62,
		"purchasing_index": 139.95
	},
	"Singapore, Singapore": {
		"slug": "singapore",
		"currency_type": "SGD",
		"index": 76.57,
		"rent_index": 70.22,
		"groceries_index": 71.68,
		"restaurant_index": 58.33,
		"purchasing_index": 92.7
	},
	"Aalborg, Denmark": {
		"slug": "",
		"currency_type": "DKK",
		"index": 54.26,
		"rent_index": 24.07,
		"groceries_index": 64.36,
		"restaurant_index": 95.79,
		"purchasing_index": 98.61
	},
	"Asheville, NC, United States": {
		"slug": "asheville",
		"currency_type": "USD",
		"index": 60.37,
		"rent_index": 36.91,
		"groceries_index": 93.35,
		"restaurant_index": 71.08,
		"purchasing_index": 148.27
	},
	"Arhus, Denmark": {
		"slug": "aarhus",
		"currency_type": "DKK",
		"index": 56.53,
		"rent_index": 28.96,
		"groceries_index": 59.76,
		"restaurant_index": 101.04,
		"purchasing_index": 105.38
	},
	"Albany, NY, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 58.09,
		"rent_index": 32.29,
		"groceries_index": 89.49,
		"restaurant_index": 69.64,
		"purchasing_index": 151.44
	},
	"London, United Kingdom": {
		"slug": "london",
		"currency_type": "GBP",
		"index": 75.99,
		"rent_index": 69.87,
		"groceries_index": 59.49,
		"restaurant_index": 88.76,
		"purchasing_index": 83.32
	},
	"Ramat Gan, Israel": {
		"slug": "",
		"currency_type": "ILS",
		"index": 56.84,
		"rent_index": 30.44,
		"groceries_index": 67.86,
		"restaurant_index": 86.84,
		"purchasing_index": 84.73
	},
	"Trieste, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 51.5,
		"rent_index": 19.3,
		"groceries_index": 70.31,
		"restaurant_index": 81.74,
		"purchasing_index": 72.29
	},
	"Parma, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 52.58,
		"rent_index": 21.66,
		"groceries_index": 71.08,
		"restaurant_index": 86.63,
		"purchasing_index": 69.33
	},
	"Greensboro, NC, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 54.53,
		"rent_index": 25.81,
		"groceries_index": 86.64,
		"restaurant_index": 63.56,
		"purchasing_index": 140.95
	},
	"Baltimore, MD, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 65.67,
		"rent_index": 49.26,
		"groceries_index": 81.39,
		"restaurant_index": 79.11,
		"purchasing_index": 128.67
	},
	"Los Angeles, CA, United States": {
		"slug": "los-angeles",
		"currency_type": "USD",
		"index": 74.65,
		"rent_index": 68.11,
		"groceries_index": 76.53,
		"restaurant_index": 82.39,
		"purchasing_index": 124.27
	},
	"Portland, OR, United States": {
		"slug": "portland-or",
		"currency_type": "USD",
		"index": 67.28,
		"rent_index": 52.81,
		"groceries_index": 81.48,
		"restaurant_index": 71.93,
		"purchasing_index": 117.83
	},
	"West Palm Beach, FL, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 63.33,
		"rent_index": 44.61,
		"groceries_index": 82.9,
		"restaurant_index": 77.07,
		"purchasing_index": 120.48
	},
	"Melbourne, Australia": {
		"slug": "melbourne",
		"currency_type": "AUD",
		"index": 62.63,
		"rent_index": 43.41,
		"groceries_index": 77.04,
		"restaurant_index": 72.73,
		"purchasing_index": 127.42
	},
	"Christchurch, New Zealand": {
		"slug": "christchurch",
		"currency_type": "NZD",
		"index": 56.73,
		"rent_index": 31.13,
		"groceries_index": 74.3,
		"restaurant_index": 80.9,
		"purchasing_index": 72.91
	},
	"Bolzano-Bozen, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 54.02,
		"rent_index": 25.51,
		"groceries_index": 78.47,
		"restaurant_index": 76.9,
		"purchasing_index": 64.83
	},
	"Sacramento, CA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 61.27,
		"rent_index": 40.65,
		"groceries_index": 81.37,
		"restaurant_index": 72.78,
		"purchasing_index": 122.17
	},
	"Adelaide, Australia": {
		"slug": "adelaide",
		"currency_type": "AUD",
		"index": 57.11,
		"rent_index": 31.96,
		"groceries_index": 75.81,
		"restaurant_index": 74.5,
		"purchasing_index": 110.82
	},
	"New Orleans, LA, United States": {
		"slug": "new-orleans",
		"currency_type": "USD",
		"index": 61.25,
		"rent_index": 40.73,
		"groceries_index": 80.91,
		"restaurant_index": 81.36,
		"purchasing_index": 98.33
	},
	"Tel Aviv-yafo, Israel": {
		"slug": "tel-aviv",
		"currency_type": "ILS",
		"index": 60.56,
		"rent_index": 39.32,
		"groceries_index": 66.22,
		"restaurant_index": 86.79,
		"purchasing_index": 90
	},
	"Hartford, CT, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 61.88,
		"rent_index": 42.11,
		"groceries_index": 80.68,
		"restaurant_index": 82.9,
		"purchasing_index": 107.34
	},
	"Santa Barbara, CA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 76.98,
		"rent_index": 73.63,
		"groceries_index": 76.53,
		"restaurant_index": 87.54,
		"purchasing_index": 111.17
	},
	"Hong Kong, Hong Kong": {
		"slug": "hong-kong",
		"currency_type": "HKD",
		"index": 81.93,
		"rent_index": 84.08,
		"groceries_index": 81.88,
		"restaurant_index": 54.87,
		"purchasing_index": 81.45
	},
	"Cairns, Australia": {
		"slug": "",
		"currency_type": "AUD",
		"index": 55.91,
		"rent_index": 29.8,
		"groceries_index": 77.98,
		"restaurant_index": 75.44,
		"purchasing_index": 73.76
	},
	"Luxembourg, Luxembourg": {
		"slug": "luxembourg",
		"currency_type": "EUR",
		"index": 66.11,
		"rent_index": 51.18,
		"groceries_index": 64.79,
		"restaurant_index": 94.19,
		"purchasing_index": 117.13
	},
	"Brisbane, Australia": {
		"slug": "brisbane",
		"currency_type": "AUD",
		"index": 62.69,
		"rent_index": 44.11,
		"groceries_index": 73.72,
		"restaurant_index": 75.09,
		"purchasing_index": 118.86
	},
	"Seoul, South Korea": {
		"slug": "seoul",
		"currency_type": "KRW",
		"index": 59.34,
		"rent_index": 37.15,
		"groceries_index": 93.98,
		"restaurant_index": 44.81,
		"purchasing_index": 90.86
	},
	"Dublin, Ireland": {
		"slug": "dublin",
		"currency_type": "EUR",
		"index": 65.37,
		"rent_index": 49.78,
		"groceries_index": 63.07,
		"restaurant_index": 84.14,
		"purchasing_index": 99
	},
	"Orlando, FL, United States": {
		"slug": "orlando",
		"currency_type": "USD",
		"index": 60.69,
		"rent_index": 40.23,
		"groceries_index": 83.92,
		"restaurant_index": 76.45,
		"purchasing_index": 107.49
	},
	"Jerusalem, Israel": {
		"slug": "",
		"currency_type": "ILS",
		"index": 55.62,
		"rent_index": 29.71,
		"groceries_index": 66.45,
		"restaurant_index": 85.1,
		"purchasing_index": 87.37
	},
	"Waterloo, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 55.18,
		"rent_index": 28.81,
		"groceries_index": 78.24,
		"restaurant_index": 67.53,
		"purchasing_index": 125.13
	},
	"Des Moines, IA, United States": {
		"slug": "des-moines",
		"currency_type": "USD",
		"index": 56.98,
		"rent_index": 32.62,
		"groceries_index": 89.98,
		"restaurant_index": 64.63,
		"purchasing_index": 94.83
	},
	"Antwerp, Belgium": {
		"slug": "",
		"currency_type": "EUR",
		"index": 53.66,
		"rent_index": 25.81,
		"groceries_index": 71.74,
		"restaurant_index": 86.44,
		"purchasing_index": 86.99
	},
	"Hobart, Australia": {
		"slug": "",
		"currency_type": "AUD",
		"index": 55.24,
		"rent_index": 29.49,
		"groceries_index": 74.9,
		"restaurant_index": 85.18,
		"purchasing_index": 94.99
	},
	"Busan, South Korea": {
		"slug": "",
		"currency_type": "KRW",
		"index": 50.52,
		"rent_index": 20,
		"groceries_index": 94.33,
		"restaurant_index": 49.65,
		"purchasing_index": 102.61
	},
	"Gent, Belgium": {
		"slug": "",
		"currency_type": "EUR",
		"index": 52.71,
		"rent_index": 24.64,
		"groceries_index": 71.64,
		"restaurant_index": 82.92,
		"purchasing_index": 91.01
	},
	"Jersey City, NJ, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 73.82,
		"rent_index": 68.71,
		"groceries_index": 76.34,
		"restaurant_index": 72.81,
		"purchasing_index": 151.55
	},
	"Fort Lauderdale, FL, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 68.06,
		"rent_index": 56.71,
		"groceries_index": 76.39,
		"restaurant_index": 76.53,
		"purchasing_index": 105.05
	},
	"Grand Rapids, MI, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 57.32,
		"rent_index": 34.44,
		"groceries_index": 78.55,
		"restaurant_index": 73.73,
		"purchasing_index": 132.41
	},
	"Helsinki, Finland": {
		"slug": "helsinki",
		"currency_type": "EUR",
		"index": 58.5,
		"rent_index": 36.93,
		"groceries_index": 66.79,
		"restaurant_index": 85.36,
		"purchasing_index": 110.6
	},
	"Cleveland, OH, United States": {
		"slug": "cleveland",
		"currency_type": "USD",
		"index": 57.08,
		"rent_index": 34,
		"groceries_index": 77.55,
		"restaurant_index": 70.58,
		"purchasing_index": 116.16
	},
	"Saskatoon, Canada": {
		"slug": "saskatoon",
		"currency_type": "CAD",
		"index": 54.15,
		"rent_index": 28.09,
		"groceries_index": 80.29,
		"restaurant_index": 71.64,
		"purchasing_index": 95.16
	},
	"Tacoma, WA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 57.43,
		"rent_index": 35.07,
		"groceries_index": 75.47,
		"restaurant_index": 66.97,
		"purchasing_index": 118.7
	},
	"Amsterdam, Netherlands": {
		"slug": "amsterdam",
		"currency_type": "EUR",
		"index": 62.69,
		"rent_index": 46.04,
		"groceries_index": 62.29,
		"restaurant_index": 83.98,
		"purchasing_index": 90.41
	},
	"San Diego, CA, United States": {
		"slug": "san-diego",
		"currency_type": "USD",
		"index": 70.08,
		"rent_index": 61.54,
		"groceries_index": 77.09,
		"restaurant_index": 77.42,
		"purchasing_index": 128.92
	},
	"Canberra, Australia": {
		"slug": "",
		"currency_type": "AUD",
		"index": 61.11,
		"rent_index": 43.25,
		"groceries_index": 76.86,
		"restaurant_index": 72.19,
		"purchasing_index": 141.65
	},
	"The Hague (Den Haag), Netherlands": {
		"slug": "the-hague",
		"currency_type": "EUR",
		"index": 58.09,
		"rent_index": 37.15,
		"groceries_index": 61.06,
		"restaurant_index": 83.05,
		"purchasing_index": 86.72
	},
	"Genoa, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 49.55,
		"rent_index": 19.36,
		"groceries_index": 70.38,
		"restaurant_index": 71.13,
		"purchasing_index": 60.64
	},
	"Jacksonville, FL, United States": {
		"slug": "jacksonville",
		"currency_type": "USD",
		"index": 55.63,
		"rent_index": 32.07,
		"groceries_index": 80.12,
		"restaurant_index": 74.92,
		"purchasing_index": 112.56
	},
	"Wellington, New Zealand": {
		"slug": "wellington",
		"currency_type": "NZD",
		"index": 56.68,
		"rent_index": 34.28,
		"groceries_index": 72.41,
		"restaurant_index": 70.88,
		"purchasing_index": 120.31
	},
	"Detroit, MI, United States": {
		"slug": "detroit",
		"currency_type": "USD",
		"index": 57.79,
		"rent_index": 36.69,
		"groceries_index": 78.23,
		"restaurant_index": 65.26,
		"purchasing_index": 133.91
	},
	"Turku, Finland": {
		"slug": "turku",
		"currency_type": "EUR",
		"index": 51.13,
		"rent_index": 22.81,
		"groceries_index": 66.65,
		"restaurant_index": 81.46,
		"purchasing_index": 115.5
	},
	"Maastricht, Netherlands": {
		"slug": "",
		"currency_type": "EUR",
		"index": 53.98,
		"rent_index": 28.8,
		"groceries_index": 72.11,
		"restaurant_index": 74.36,
		"purchasing_index": 97.56
	},
	"Harrisburg, PA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 52.56,
		"rent_index": 26,
		"groceries_index": 83.25,
		"restaurant_index": 65.36,
		"purchasing_index": 132.14
	},
	"Newcastle, Australia": {
		"slug": "",
		"currency_type": "AUD",
		"index": 60.15,
		"rent_index": 41.85,
		"groceries_index": 78.4,
		"restaurant_index": 79.46,
		"purchasing_index": 131.79
	},
	"Fayetteville, AR, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 50.8,
		"rent_index": 22.54,
		"groceries_index": 82.56,
		"restaurant_index": 67.5,
		"purchasing_index": 83.87
	},
	"Milan, Italy": {
		"slug": "milan",
		"currency_type": "EUR",
		"index": 58.13,
		"rent_index": 37.82,
		"groceries_index": 68.07,
		"restaurant_index": 81.06,
		"purchasing_index": 76.86
	},
	"Lyon, France": {
		"slug": "lyon",
		"currency_type": "EUR",
		"index": 51.06,
		"rent_index": 23.25,
		"groceries_index": 73.52,
		"restaurant_index": 69.58,
		"purchasing_index": 98.14
	},
	"Red Deer, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 52.47,
		"rent_index": 26.19,
		"groceries_index": 72.74,
		"restaurant_index": 73.73,
		"purchasing_index": 103.82
	},
	"Saint Paul, MN, United States": {
		"slug": "minneapolis-saint-paul",
		"currency_type": "USD",
		"index": 57.51,
		"rent_index": 36.84,
		"groceries_index": 79.84,
		"restaurant_index": 64.92,
		"purchasing_index": 104.6
	},
	"Halifax, Canada": {
		"slug": "halifax",
		"currency_type": "CAD",
		"index": 53.53,
		"rent_index": 28.58,
		"groceries_index": 80.69,
		"restaurant_index": 70.75,
		"purchasing_index": 94.86
	},
	"Nashville, TN, United States": {
		"slug": "nashville",
		"currency_type": "USD",
		"index": 61.75,
		"rent_index": 45.79,
		"groceries_index": 77.32,
		"restaurant_index": 74.26,
		"purchasing_index": 127.93
	},
	"Milwaukee, WI, United States": {
		"slug": "milwaukee",
		"currency_type": "USD",
		"index": 56.46,
		"rent_index": 35.03,
		"groceries_index": 75.72,
		"restaurant_index": 75.18,
		"purchasing_index": 122.87
	},
	"Cagliari, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 49.41,
		"rent_index": 20.32,
		"groceries_index": 65.37,
		"restaurant_index": 73.93,
		"purchasing_index": 49.15
	},
	"Indianapolis, IN, United States": {
		"slug": "indianapolis",
		"currency_type": "USD",
		"index": 54.4,
		"rent_index": 30.79,
		"groceries_index": 79.48,
		"restaurant_index": 67.08,
		"purchasing_index": 94.08
	},
	"Atlanta, GA, United States": {
		"slug": "atlanta",
		"currency_type": "USD",
		"index": 60.72,
		"rent_index": 44.01,
		"groceries_index": 76.45,
		"restaurant_index": 74.11,
		"purchasing_index": 148.36
	},
	"Gothenburg, Sweden": {
		"slug": "gothenburg",
		"currency_type": "SEK",
		"index": 53.59,
		"rent_index": 29.24,
		"groceries_index": 69.19,
		"restaurant_index": 79.15,
		"purchasing_index": 112.08
	},
	"Brussels, Belgium": {
		"slug": "brussels",
		"currency_type": "EUR",
		"index": 54.74,
		"rent_index": 31.79,
		"groceries_index": 66.45,
		"restaurant_index": 82.92,
		"purchasing_index": 95.8
	},
	"Charlotte, NC, United States": {
		"slug": "charlotte",
		"currency_type": "USD",
		"index": 58.74,
		"rent_index": 40.15,
		"groceries_index": 77.42,
		"restaurant_index": 72.48,
		"purchasing_index": 117.9
	},
	"Hamburg, Germany": {
		"slug": "hamburg",
		"currency_type": "EUR",
		"index": 53.63,
		"rent_index": 29.57,
		"groceries_index": 60.87,
		"restaurant_index": 66,
		"purchasing_index": 106.88
	},
	"Tampa, FL, United States": {
		"slug": "tampa-bay-area",
		"currency_type": "USD",
		"index": 58.87,
		"rent_index": 40.53,
		"groceries_index": 80.03,
		"restaurant_index": 70.37,
		"purchasing_index": 100.2
	},
	"Syracuse, NY, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 52.23,
		"rent_index": 26.98,
		"groceries_index": 76.85,
		"restaurant_index": 62.69,
		"purchasing_index": 95.49
	},
	"Houston, TX, United States": {
		"slug": "houston",
		"currency_type": "USD",
		"index": 61.11,
		"rent_index": 45.59,
		"groceries_index": 73.66,
		"restaurant_index": 77.51,
		"purchasing_index": 150.24
	},
	"Saint Louis, MO, United States": {
		"slug": "st-louis",
		"currency_type": "USD",
		"index": 53.22,
		"rent_index": 29.23,
		"groceries_index": 74.87,
		"restaurant_index": 72.33,
		"purchasing_index": 141.86
	},
	"Calgary, Canada": {
		"slug": "calgary",
		"currency_type": "CAD",
		"index": 55.93,
		"rent_index": 34.98,
		"groceries_index": 73.42,
		"restaurant_index": 71.66,
		"purchasing_index": 116.66
	},
	"Frankfurt, Germany": {
		"slug": "frankfurt",
		"currency_type": "EUR",
		"index": 55.2,
		"rent_index": 33.46,
		"groceries_index": 64.43,
		"restaurant_index": 66.44,
		"purchasing_index": 114.94
	},
	"Brighton, United Kingdom": {
		"slug": "brighton",
		"currency_type": "GBP",
		"index": 58.05,
		"rent_index": 39.74,
		"groceries_index": 63.85,
		"restaurant_index": 84.22,
		"purchasing_index": 79.22
	},
	"Tampere, Finland": {
		"slug": "tampere",
		"currency_type": "EUR",
		"index": 50.87,
		"rent_index": 24.85,
		"groceries_index": 62.2,
		"restaurant_index": 84.59,
		"purchasing_index": 103.3
	},
	"Birmingham, AL, United States": {
		"slug": "birmingham-al",
		"currency_type": "USD",
		"index": 52.37,
		"rent_index": 28.02,
		"groceries_index": 73.98,
		"restaurant_index": 74.09,
		"purchasing_index": 137.64
	},
	"Aberdeen, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 53.43,
		"rent_index": 30.25,
		"groceries_index": 60.97,
		"restaurant_index": 83.43,
		"purchasing_index": 112.13
	},
	"Bergamo, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 48.27,
		"rent_index": 19.5,
		"groceries_index": 61.03,
		"restaurant_index": 85,
		"purchasing_index": 67.16
	},
	"Wichita, KS, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 51.03,
		"rent_index": 25.33,
		"groceries_index": 81.3,
		"restaurant_index": 67.43,
		"purchasing_index": 105.11
	},
	"Fresno, CA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 53.71,
		"rent_index": 30.99,
		"groceries_index": 74.2,
		"restaurant_index": 72.13,
		"purchasing_index": 107.14
	},
	"Bakersfield, CA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 51.88,
		"rent_index": 27.38,
		"groceries_index": 74.87,
		"restaurant_index": 74.44,
		"purchasing_index": 130.04
	},
	"Louisville, KY, United States": {
		"slug": "louisville",
		"currency_type": "USD",
		"index": 52.25,
		"rent_index": 28.27,
		"groceries_index": 83.93,
		"restaurant_index": 62.94,
		"purchasing_index": 124.18
	},
	"Cork, Ireland": {
		"slug": "cork",
		"currency_type": "EUR",
		"index": 55.18,
		"rent_index": 34.52,
		"groceries_index": 61.25,
		"restaurant_index": 76.48,
		"purchasing_index": 116.8
	},
	"Greenville, SC, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 56.5,
		"rent_index": 37.32,
		"groceries_index": 79.05,
		"restaurant_index": 67.54,
		"purchasing_index": 137.12
	},
	"Bellingham, WA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 54.47,
		"rent_index": 33.15,
		"groceries_index": 75.81,
		"restaurant_index": 71.52,
		"purchasing_index": 102.49
	},
	"Haifa, Israel": {
		"slug": "",
		"currency_type": "ILS",
		"index": 48.38,
		"rent_index": 20.46,
		"groceries_index": 59.25,
		"restaurant_index": 82.99,
		"purchasing_index": 98.05
	},
	"Chattanooga, TN, United States": {
		"slug": "chattanooga",
		"currency_type": "USD",
		"index": 51.64,
		"rent_index": 27.27,
		"groceries_index": 77.71,
		"restaurant_index": 65.38,
		"purchasing_index": 128.62
	},
	"Austin, TX, United States": {
		"slug": "austin",
		"currency_type": "USD",
		"index": 63.18,
		"rent_index": 51.35,
		"groceries_index": 73.6,
		"restaurant_index": 71.27,
		"purchasing_index": 126.85
	},
	"Rome, Italy": {
		"slug": "rome",
		"currency_type": "EUR",
		"index": 56.39,
		"rent_index": 37.18,
		"groceries_index": 64.5,
		"restaurant_index": 74.29,
		"purchasing_index": 72.41
	},
	"Victoria, Canada": {
		"slug": "victoria",
		"currency_type": "CAD",
		"index": 54.6,
		"rent_index": 33.76,
		"groceries_index": 77.51,
		"restaurant_index": 67.22,
		"purchasing_index": 118.14
	},
	"Tallahassee, FL, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 52.7,
		"rent_index": 29.83,
		"groceries_index": 82.01,
		"restaurant_index": 60.76,
		"purchasing_index": 105.59
	},
	"Toulouse, France": {
		"slug": "toulouse",
		"currency_type": "EUR",
		"index": 49.91,
		"rent_index": 24.05,
		"groceries_index": 67.07,
		"restaurant_index": 76.87,
		"purchasing_index": 107.05
	},
	"Buffalo, NY, United States": {
		"slug": "buffalo",
		"currency_type": "USD",
		"index": 52.22,
		"rent_index": 28.89,
		"groceries_index": 74.14,
		"restaurant_index": 66.34,
		"purchasing_index": 115.19
	},
	"Bournemouth, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 53.38,
		"rent_index": 31.31,
		"groceries_index": 67.5,
		"restaurant_index": 74.71,
		"purchasing_index": 84.86
	},
	"Utrecht, Netherlands": {
		"slug": "utrecht",
		"currency_type": "EUR",
		"index": 55.25,
		"rent_index": 35.48,
		"groceries_index": 60.08,
		"restaurant_index": 82.74,
		"purchasing_index": 101.16
	},
	"Cambridge, United Kingdom": {
		"slug": "cambridge",
		"currency_type": "GBP",
		"index": 57.35,
		"rent_index": 39.93,
		"groceries_index": 59.48,
		"restaurant_index": 84.87,
		"purchasing_index": 98.47
	},
	"Gold Coast, Australia": {
		"slug": "",
		"currency_type": "AUD",
		"index": 55.71,
		"rent_index": 36.74,
		"groceries_index": 71.58,
		"restaurant_index": 66.12,
		"purchasing_index": 104.38
	},
	"Milton Keynes, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 55.48,
		"rent_index": 36.38,
		"groceries_index": 64.36,
		"restaurant_index": 73.84,
		"purchasing_index": 88.94
	},
	"Newark, NJ, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 55.2,
		"rent_index": 36.02,
		"groceries_index": 63.01,
		"restaurant_index": 81.29,
		"purchasing_index": 125.8
	},
	"Spokane, WA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 50.75,
		"rent_index": 26.85,
		"groceries_index": 74.69,
		"restaurant_index": 67.14,
		"purchasing_index": 112.05
	},
	"Edmonton, Canada": {
		"slug": "edmonton",
		"currency_type": "CAD",
		"index": 52.27,
		"rent_index": 30.03,
		"groceries_index": 71.67,
		"restaurant_index": 67.3,
		"purchasing_index": 113.83
	},
	"Vancouver, Canada": {
		"slug": "vancouver",
		"currency_type": "CAD",
		"index": 60.25,
		"rent_index": 46.72,
		"groceries_index": 76.48,
		"restaurant_index": 66.48,
		"purchasing_index": 91.28
	},
	"Raleigh, NC, United States": {
		"slug": "raleigh",
		"currency_type": "USD",
		"index": 55.26,
		"rent_index": 36.33,
		"groceries_index": 77.31,
		"restaurant_index": 70.46,
		"purchasing_index": 146.98
	},
	"Eugene, OR, United States": {
		"slug": "eugene",
		"currency_type": "USD",
		"index": 52.37,
		"rent_index": 30.4,
		"groceries_index": 75.33,
		"restaurant_index": 64.52,
		"purchasing_index": 130.03
	},
	"Mississauga, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 54.46,
		"rent_index": 34.8,
		"groceries_index": 68.44,
		"restaurant_index": 68.92,
		"purchasing_index": 93.42
	},
	"Little Rock, AR, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 50.4,
		"rent_index": 26.41,
		"groceries_index": 76.41,
		"restaurant_index": 64.53,
		"purchasing_index": 124.98
	},
	"San Juan, Puerto Rico": {
		"slug": "san-juan",
		"currency_type": "USD",
		"index": 50.68,
		"rent_index": 27.04,
		"groceries_index": 67.31,
		"restaurant_index": 71.94,
		"purchasing_index": 79.2
	},
	"Barrie, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 49.97,
		"rent_index": 25.6,
		"groceries_index": 71.7,
		"restaurant_index": 62.35,
		"purchasing_index": 126.54
	},
	"London, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 49.24,
		"rent_index": 24.28,
		"groceries_index": 73.52,
		"restaurant_index": 64.06,
		"purchasing_index": 104.04
	},
	"Regina, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 50.62,
		"rent_index": 27.28,
		"groceries_index": 73.92,
		"restaurant_index": 64.58,
		"purchasing_index": 115.17
	},
	"Edinburgh, United Kingdom": {
		"slug": "edinburgh",
		"currency_type": "GBP",
		"index": 52.28,
		"rent_index": 30.81,
		"groceries_index": 62.3,
		"restaurant_index": 75.07,
		"purchasing_index": 100.17
	},
	"Fort Worth, TX, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 54.65,
		"rent_index": 35.83,
		"groceries_index": 73.36,
		"restaurant_index": 63.56,
		"purchasing_index": 149.47
	},
	"Rotterdam, Netherlands": {
		"slug": "rotterdam",
		"currency_type": "EUR",
		"index": 50.23,
		"rent_index": 26.67,
		"groceries_index": 53.09,
		"restaurant_index": 83.18,
		"purchasing_index": 100.43
	},
	"Munich, Germany": {
		"slug": "munich",
		"currency_type": "EUR",
		"index": 56.45,
		"rent_index": 39.74,
		"groceries_index": 56.55,
		"restaurant_index": 71.19,
		"purchasing_index": 123.5
	},
	"Virginia Beach, VA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 54.99,
		"rent_index": 36.7,
		"groceries_index": 73.35,
		"restaurant_index": 68.02,
		"purchasing_index": 121.55
	},
	"Dayton, OH, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 47.87,
		"rent_index": 21.95,
		"groceries_index": 74.39,
		"restaurant_index": 57.67,
		"purchasing_index": 120.43
	},
	"Columbus, OH, United States": {
		"slug": "columbus",
		"currency_type": "USD",
		"index": 53.65,
		"rent_index": 34.03,
		"groceries_index": 69.84,
		"restaurant_index": 64.08,
		"purchasing_index": 120.68
	},
	"Vancouver, WA, United States": {
		"slug": "vancouver",
		"currency_type": "USD",
		"index": 53.58,
		"rent_index": 33.91,
		"groceries_index": 70.53,
		"restaurant_index": 64.45,
		"purchasing_index": 132.55
	},
	"Oxford, United Kingdom": {
		"slug": "oxford",
		"currency_type": "GBP",
		"index": 60.15,
		"rent_index": 47.66,
		"groceries_index": 59.31,
		"restaurant_index": 75.85,
		"purchasing_index": 86.58
	},
	"Columbia, SC, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 52.09,
		"rent_index": 30.86,
		"groceries_index": 78.55,
		"restaurant_index": 63.75,
		"purchasing_index": 84.28
	},
	"Las Vegas, NV, United States": {
		"slug": "las-vegas",
		"currency_type": "USD",
		"index": 52.2,
		"rent_index": 31.08,
		"groceries_index": 63.27,
		"restaurant_index": 74.31,
		"purchasing_index": 145.23
	},
	"Reading, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 55.46,
		"rent_index": 37.91,
		"groceries_index": 52.42,
		"restaurant_index": 85.56,
		"purchasing_index": 108.6
	},
	"Lille, France": {
		"slug": "lille",
		"currency_type": "EUR",
		"index": 47.87,
		"rent_index": 22.1,
		"groceries_index": 61.5,
		"restaurant_index": 69.09,
		"purchasing_index": 93.39
	},
	"Dubai, United Arab Emirates": {
		"slug": "dubai",
		"currency_type": "AED",
		"index": 72.86,
		"rent_index": 74.39,
		"groceries_index": 59.57,
		"restaurant_index": 65.68,
		"purchasing_index": 113.31
	},
	"Fremont, CA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 71.07,
		"rent_index": 70.7,
		"groceries_index": 59.86,
		"restaurant_index": 74.18,
		"purchasing_index": 150.85
	},
	"Bologna, Italy": {
		"slug": "bologna",
		"currency_type": "EUR",
		"index": 48.26,
		"rent_index": 23.31,
		"groceries_index": 62.61,
		"restaurant_index": 71.06,
		"purchasing_index": 82.83
	},
	"Windsor, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 47.17,
		"rent_index": 21.05,
		"groceries_index": 63.88,
		"restaurant_index": 61.51,
		"purchasing_index": 116.5
	},
	"Trento, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 48.89,
		"rent_index": 24.7,
		"groceries_index": 64.29,
		"restaurant_index": 67.69,
		"purchasing_index": 85.78
	},
	"Montreal, Canada": {
		"slug": "montreal",
		"currency_type": "CAD",
		"index": 49.2,
		"rent_index": 25.33,
		"groceries_index": 75.37,
		"restaurant_index": 63.25,
		"purchasing_index": 103.16
	},
	"Salem, OR, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 51.48,
		"rent_index": 30.16,
		"groceries_index": 70.91,
		"restaurant_index": 71.93,
		"purchasing_index": 77.9
	},
	"Knoxville, TN, United States": {
		"slug": "knoxville",
		"currency_type": "USD",
		"index": 51.93,
		"rent_index": 31.21,
		"groceries_index": 76.22,
		"restaurant_index": 65.75,
		"purchasing_index": 144.89
	},
	"Malmo, Sweden": {
		"slug": "malmo",
		"currency_type": "EUR",
		"index": 50,
		"rent_index": 27.26,
		"groceries_index": 66.45,
		"restaurant_index": 73.83,
		"purchasing_index": 135.27
	},
	"Galway, Ireland": {
		"slug": "gaillimh",
		"currency_type": "EUR",
		"index": 51.51,
		"rent_index": 30.62,
		"groceries_index": 59.99,
		"restaurant_index": 71.02,
		"purchasing_index": 121.98
	},
	"Cincinnati, OH, United States": {
		"slug": "cincinnati",
		"currency_type": "USD",
		"index": 51.96,
		"rent_index": 31.57,
		"groceries_index": 66.83,
		"restaurant_index": 66.88,
		"purchasing_index": 128.35
	},
	"Tulsa, OK, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 51.24,
		"rent_index": 30.18,
		"groceries_index": 73.5,
		"restaurant_index": 60.96,
		"purchasing_index": 135.62
	},
	"Bristol, United Kingdom": {
		"slug": "bristol",
		"currency_type": "GBP",
		"index": 54.04,
		"rent_index": 36.15,
		"groceries_index": 61.42,
		"restaurant_index": 77.77,
		"purchasing_index": 92.54
	},
	"Fort Wayne, IN, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 47.61,
		"rent_index": 22.73,
		"groceries_index": 76.34,
		"restaurant_index": 67.95,
		"purchasing_index": 143.31
	},
	"Fort Myers, FL, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 50.8,
		"rent_index": 29.5,
		"groceries_index": 72.42,
		"restaurant_index": 62.4,
		"purchasing_index": 92.92
	},
	"Toronto, Canada": {
		"slug": "toronto",
		"currency_type": "CAD",
		"index": 56.18,
		"rent_index": 40.84,
		"groceries_index": 65.44,
		"restaurant_index": 67.11,
		"purchasing_index": 115.94
	},
	"Eindhoven, Netherlands": {
		"slug": "eindhoven",
		"currency_type": "EUR",
		"index": 50.94,
		"rent_index": 29.92,
		"groceries_index": 54.09,
		"restaurant_index": 81.61,
		"purchasing_index": 116.79
	},
	"Winnipeg, Canada": {
		"slug": "winnipeg",
		"currency_type": "CAD",
		"index": 49.12,
		"rent_index": 26.21,
		"groceries_index": 68.7,
		"restaurant_index": 67.19,
		"purchasing_index": 87.99
	},
	"Dallas, TX, United States": {
		"slug": "dallas",
		"currency_type": "USD",
		"index": 56.74,
		"rent_index": 42.11,
		"groceries_index": 65.29,
		"restaurant_index": 70.5,
		"purchasing_index": 163.48
	},
	"Montevideo, Uruguay": {
		"slug": "montevideo",
		"currency_type": "UYU",
		"index": 45.77,
		"rent_index": 19.26,
		"groceries_index": 56.47,
		"restaurant_index": 67.79,
		"purchasing_index": 32.43
	},
	"Gainesville, FL, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 50.61,
		"rent_index": 29.44,
		"groceries_index": 71.43,
		"restaurant_index": 61.09,
		"purchasing_index": 94.1
	},
	"Ad Dammam, Saudi Arabia": {
		"slug": "",
		"currency_type": "SAR",
		"index": 42.93,
		"rent_index": 13.44,
		"groceries_index": 85.81,
		"restaurant_index": 32.15,
		"purchasing_index": 108.07
	},
	"Uppsala, Sweden": {
		"slug": "uppsala",
		"currency_type": "EUR",
		"index": 48.84,
		"rent_index": 25.78,
		"groceries_index": 57.81,
		"restaurant_index": 75.21,
		"purchasing_index": 111.1
	},
	"Ann Arbor, MI, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 56.56,
		"rent_index": 42.06,
		"groceries_index": 67.4,
		"restaurant_index": 63.21,
		"purchasing_index": 153.16
	},
	"Rochester, NY, United States": {
		"slug": "rochester",
		"currency_type": "USD",
		"index": 50.59,
		"rent_index": 29.81,
		"groceries_index": 69.1,
		"restaurant_index": 71.14,
		"purchasing_index": 130.05
	},
	"Madison, WI, United States": {
		"slug": "madison",
		"currency_type": "USD",
		"index": 54.56,
		"rent_index": 38.24,
		"groceries_index": 66.05,
		"restaurant_index": 67.52,
		"purchasing_index": 137.44
	},
	"Leiden, Netherlands": {
		"slug": "",
		"currency_type": "EUR",
		"index": 49.64,
		"rent_index": 28.33,
		"groceries_index": 54.45,
		"restaurant_index": 80.61,
		"purchasing_index": 101.49
	},
	"Groningen, Netherlands": {
		"slug": "",
		"currency_type": "EUR",
		"index": 48.94,
		"rent_index": 26.89,
		"groceries_index": 57.5,
		"restaurant_index": 76.79,
		"purchasing_index": 102.93
	},
	"Kansas City, MO, United States": {
		"slug": "kansas-city",
		"currency_type": "USD",
		"index": 49.88,
		"rent_index": 29,
		"groceries_index": 66.65,
		"restaurant_index": 70.36,
		"purchasing_index": 156.57
	},
	"Phoenix, AZ, United States": {
		"slug": "phoenix",
		"currency_type": "USD",
		"index": 51.2,
		"rent_index": 31.76,
		"groceries_index": 61.46,
		"restaurant_index": 75.44,
		"purchasing_index": 146.53
	},
	"Manchester, United Kingdom": {
		"slug": "manchester",
		"currency_type": "GBP",
		"index": 49.57,
		"rent_index": 28.39,
		"groceries_index": 56.36,
		"restaurant_index": 79.57,
		"purchasing_index": 97
	},
	"Norwich, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 47.5,
		"rent_index": 24.07,
		"groceries_index": 54.1,
		"restaurant_index": 74.57,
		"purchasing_index": 84.92
	},
	"Doha, Qatar": {
		"slug": "doha",
		"currency_type": "QAR",
		"index": 68.11,
		"rent_index": 67.13,
		"groceries_index": 55.38,
		"restaurant_index": 72.42,
		"purchasing_index": 111.7
	},
	"Glasgow, United Kingdom": {
		"slug": "glasgow",
		"currency_type": "GBP",
		"index": 49.39,
		"rent_index": 28.19,
		"groceries_index": 58.13,
		"restaurant_index": 77.13,
		"purchasing_index": 103.45
	},
	"Exeter, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 49.64,
		"rent_index": 28.71,
		"groceries_index": 56.11,
		"restaurant_index": 77.54,
		"purchasing_index": 74.64
	},
	"Kingston, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 48.79,
		"rent_index": 27.08,
		"groceries_index": 69.11,
		"restaurant_index": 63.38,
		"purchasing_index": 95.77
	},
	"Sliema, Malta": {
		"slug": "",
		"currency_type": "EUR",
		"index": 50.07,
		"rent_index": 29.8,
		"groceries_index": 61.48,
		"restaurant_index": 75.55,
		"purchasing_index": 77.22
	},
	"Southampton, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 49.63,
		"rent_index": 28.88,
		"groceries_index": 59.63,
		"restaurant_index": 68.22,
		"purchasing_index": 110.04
	},
	"Vienna, Austria": {
		"slug": "vienna",
		"currency_type": "EUR",
		"index": 50.07,
		"rent_index": 29.94,
		"groceries_index": 62.23,
		"restaurant_index": 66.64,
		"purchasing_index": 98.5
	},
	"York, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 48.83,
		"rent_index": 27.41,
		"groceries_index": 56.54,
		"restaurant_index": 77.77,
		"purchasing_index": 104.4
	},
	"Salt Lake City, UT, United States": {
		"slug": "salt-lake-city",
		"currency_type": "USD",
		"index": 52.27,
		"rent_index": 34.68,
		"groceries_index": 66.1,
		"restaurant_index": 71.06,
		"purchasing_index": 152.54
	},
	"Ottawa, Canada": {
		"slug": "ottawa",
		"currency_type": "CAD",
		"index": 50.42,
		"rent_index": 30.81,
		"groceries_index": 62.74,
		"restaurant_index": 72.91,
		"purchasing_index": 126.26
	},
	"Heidelberg, Germany": {
		"slug": "",
		"currency_type": "EUR",
		"index": 49.85,
		"rent_index": 29.91,
		"groceries_index": 53.55,
		"restaurant_index": 63.87,
		"purchasing_index": 146.5
	},
	"Quebec City, Canada": {
		"slug": "quebec",
		"currency_type": "CAD",
		"index": 44.29,
		"rent_index": 18.55,
		"groceries_index": 69.43,
		"restaurant_index": 62.18,
		"purchasing_index": 113.51
	},
	"Liverpool, United Kingdom": {
		"slug": "liverpool",
		"currency_type": "GBP",
		"index": 46.31,
		"rent_index": 22.84,
		"groceries_index": 56.31,
		"restaurant_index": 74.92,
		"purchasing_index": 113.78
	},
	"Moncton, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 44.04,
		"rent_index": 18.49,
		"groceries_index": 66.82,
		"restaurant_index": 61.27,
		"purchasing_index": 103.43
	},
	"Huntsville, AL, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 47.98,
		"rent_index": 27.12,
		"groceries_index": 63.88,
		"restaurant_index": 68.54,
		"purchasing_index": 124.94
	},
	"Surrey, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 49.01,
		"rent_index": 29.37,
		"groceries_index": 67.29,
		"restaurant_index": 63.23,
		"purchasing_index": 81.11
	},
	"Shreveport, LA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 47.08,
		"rent_index": 25.41,
		"groceries_index": 65.95,
		"restaurant_index": 64.01,
		"purchasing_index": 77.68
	},
	"Albuquerque, NM, United States": {
		"slug": "albuquerque",
		"currency_type": "USD",
		"index": 47.2,
		"rent_index": 25.83,
		"groceries_index": 65.8,
		"restaurant_index": 67.87,
		"purchasing_index": 131.25
	},
	"Karlsruhe, Germany": {
		"slug": "karlsruhe",
		"currency_type": "EUR",
		"index": 47,
		"rent_index": 25.43,
		"groceries_index": 47.91,
		"restaurant_index": 71.48,
		"purchasing_index": 125.73
	},
	"Leicester, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 44.46,
		"rent_index": 20.45,
		"groceries_index": 56.14,
		"restaurant_index": 75.56,
		"purchasing_index": 95.62
	},
	"Mobile, AL, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 46.28,
		"rent_index": 24.27,
		"groceries_index": 66.34,
		"restaurant_index": 66.28,
		"purchasing_index": 148.43
	},
	"Cologne, Germany": {
		"slug": "cologne",
		"currency_type": "EUR",
		"index": 46.99,
		"rent_index": 25.79,
		"groceries_index": 50.45,
		"restaurant_index": 64.44,
		"purchasing_index": 118.42
	},
	"Kelowna, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 49.94,
		"rent_index": 31.98,
		"groceries_index": 69.16,
		"restaurant_index": 64.96,
		"purchasing_index": 103.59
	},
	"Nantes, France": {
		"slug": "nantes",
		"currency_type": "EUR",
		"index": 44.55,
		"rent_index": 20.81,
		"groceries_index": 57.28,
		"restaurant_index": 66.72,
		"purchasing_index": 140.66
	},
	"Stuttgart, Germany": {
		"slug": "stuttgart",
		"currency_type": "EUR",
		"index": 48.57,
		"rent_index": 29.33,
		"groceries_index": 49.8,
		"restaurant_index": 65.79,
		"purchasing_index": 129.18
	},
	"Accra, Ghana": {
		"slug": "",
		"currency_type": "GHS",
		"index": 58.03,
		"rent_index": 49.11,
		"groceries_index": 61.56,
		"restaurant_index": 46.48,
		"purchasing_index": 13.26
	},
	"Taipei, Taiwan": {
		"slug": "taipei",
		"currency_type": "TWD",
		"index": 44.61,
		"rent_index": 21.12,
		"groceries_index": 80.17,
		"restaurant_index": 31.09,
		"purchasing_index": 119.79
	},
	"Oklahoma City, OK, United States": {
		"slug": "oklahoma-city",
		"currency_type": "USD",
		"index": 47.39,
		"rent_index": 26.93,
		"groceries_index": 70.12,
		"restaurant_index": 59.76,
		"purchasing_index": 126.12
	},
	"Bonn, Germany": {
		"slug": "",
		"currency_type": "EUR",
		"index": 47.96,
		"rent_index": 28.23,
		"groceries_index": 43.49,
		"restaurant_index": 61.39,
		"purchasing_index": 97.66
	},
	"Naples, Italy": {
		"slug": "naples",
		"currency_type": "EUR",
		"index": 44.1,
		"rent_index": 20.24,
		"groceries_index": 63.31,
		"restaurant_index": 56.97,
		"purchasing_index": 39.3
	},
	"Abu Dhabi, United Arab Emirates": {
		"slug": "",
		"currency_type": "AED",
		"index": 68.5,
		"rent_index": 71.26,
		"groceries_index": 55.27,
		"restaurant_index": 64.61,
		"purchasing_index": 136.07
	},
	"Guelph, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 47.27,
		"rent_index": 27.39,
		"groceries_index": 60.29,
		"restaurant_index": 62.51,
		"purchasing_index": 110.13
	},
	"Leeds, United Kingdom": {
		"slug": "leeds",
		"currency_type": "GBP",
		"index": 46.2,
		"rent_index": 25.27,
		"groceries_index": 56.22,
		"restaurant_index": 68.9,
		"purchasing_index": 106.22
	},
	"Kingston, Jamaica": {
		"slug": "kingston",
		"currency_type": "JMD",
		"index": 41.57,
		"rent_index": 15.67,
		"groceries_index": 65.67,
		"restaurant_index": 38.03,
		"purchasing_index": 36.07
	},
	"Sheffield, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 44.95,
		"rent_index": 22.9,
		"groceries_index": 54.97,
		"restaurant_index": 77.31,
		"purchasing_index": 103.88
	},
	"Boise, ID, United States": {
		"slug": "boise",
		"currency_type": "USD",
		"index": 47.65,
		"rent_index": 28.55,
		"groceries_index": 63.15,
		"restaurant_index": 67.63,
		"purchasing_index": 115.13
	},
	"Turin, Italy": {
		"slug": "turin",
		"currency_type": "EUR",
		"index": 43.17,
		"rent_index": 19.44,
		"groceries_index": 53.46,
		"restaurant_index": 68.03,
		"purchasing_index": 80.05
	},
	"Nottingham, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 44.2,
		"rent_index": 21.65,
		"groceries_index": 57.83,
		"restaurant_index": 61.42,
		"purchasing_index": 121.74
	},
	"Birmingham, United Kingdom": {
		"slug": "birmingham",
		"currency_type": "GBP",
		"index": 46.12,
		"rent_index": 26.22,
		"groceries_index": 51.47,
		"restaurant_index": 70.26,
		"purchasing_index": 97.09
	},
	"Coventry, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 46.32,
		"rent_index": 26.71,
		"groceries_index": 51.01,
		"restaurant_index": 65.74,
		"purchasing_index": 108.29
	},
	"Beirut, Lebanon": {
		"slug": "beirut",
		"currency_type": "LBP",
		"index": 51.07,
		"rent_index": 36.72,
		"groceries_index": 47.99,
		"restaurant_index": 60.93,
		"purchasing_index": 51.84
	},
	"Panama City, Panama": {
		"slug": "panama",
		"currency_type": "PAB",
		"index": 51.39,
		"rent_index": 37.44,
		"groceries_index": 65.8,
		"restaurant_index": 56.6,
		"purchasing_index": 35.14
	},
	"Bilbao, Spain": {
		"slug": "",
		"currency_type": "EUR",
		"index": 46.13,
		"rent_index": 26.46,
		"groceries_index": 54.93,
		"restaurant_index": 66.82,
		"purchasing_index": 91.88
	},
	"Berlin, Germany": {
		"slug": "berlin",
		"currency_type": "EUR",
		"index": 46.08,
		"rent_index": 26.41,
		"groceries_index": 50.66,
		"restaurant_index": 54.8,
		"purchasing_index": 116.11
	},
	"Tucson, AZ, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 45.17,
		"rent_index": 24.85,
		"groceries_index": 62.35,
		"restaurant_index": 64.8,
		"purchasing_index": 141.45
	},
	"Cardiff, United Kingdom": {
		"slug": "cardiff",
		"currency_type": "GBP",
		"index": 45.08,
		"rent_index": 24.7,
		"groceries_index": 55.34,
		"restaurant_index": 68.12,
		"purchasing_index": 105.28
	},
	"Nuremberg, Germany": {
		"slug": "",
		"currency_type": "EUR",
		"index": 43.93,
		"rent_index": 22.45,
		"groceries_index": 47.85,
		"restaurant_index": 65.69,
		"purchasing_index": 140.5
	},
	"Graz, Austria": {
		"slug": "",
		"currency_type": "EUR",
		"index": 43.61,
		"rent_index": 21.79,
		"groceries_index": 53.82,
		"restaurant_index": 59.13,
		"purchasing_index": 113.28
	},
	"Newcastle Upon Tyne, United Kingdom": {
		"slug": "",
		"currency_type": "GBP",
		"index": 44.71,
		"rent_index": 24.12,
		"groceries_index": 49.58,
		"restaurant_index": 70.96,
		"purchasing_index": 109.29
	},
	"Marseille, France": {
		"slug": "marseille",
		"currency_type": "EUR",
		"index": 42.9,
		"rent_index": 20.9,
		"groceries_index": 59.17,
		"restaurant_index": 55.9,
		"purchasing_index": 99.33
	},
	"San Antonio, TX, United States": {
		"slug": "san-antonio",
		"currency_type": "USD",
		"index": 49.33,
		"rent_index": 35.03,
		"groceries_index": 60.74,
		"restaurant_index": 59.96,
		"purchasing_index": 136.57
	},
	"Sharjah, United Arab Emirates": {
		"slug": "",
		"currency_type": "AED",
		"index": 47.31,
		"rent_index": 30.9,
		"groceries_index": 52.94,
		"restaurant_index": 43.51,
		"purchasing_index": 116.35
	},
	"San Jose, Costa Rica": {
		"slug": "san-jose",
		"currency_type": "CRC",
		"index": 42.74,
		"rent_index": 21.58,
		"groceries_index": 63.32,
		"restaurant_index": 48.38,
		"purchasing_index": 44.69
	},
	"Leipzig, Germany": {
		"slug": "leipzig",
		"currency_type": "EUR",
		"index": 40.77,
		"rent_index": 17.67,
		"groceries_index": 45.9,
		"restaurant_index": 56.93,
		"purchasing_index": 87.51
	},
	"Reno, NV, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 47.1,
		"rent_index": 31.04,
		"groceries_index": 53.07,
		"restaurant_index": 68.51,
		"purchasing_index": 109.46
	},
	"Kitchener, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 44.21,
		"rent_index": 25.07,
		"groceries_index": 54.72,
		"restaurant_index": 63.37,
		"purchasing_index": 124.49
	},
	"Amman, Jordan": {
		"slug": "",
		"currency_type": "JOD",
		"index": 38.84,
		"rent_index": 13.89,
		"groceries_index": 53.7,
		"restaurant_index": 57.28,
		"purchasing_index": 41.69
	},
	"Athens, GA, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 43.88,
		"rent_index": 24.55,
		"groceries_index": 57.16,
		"restaurant_index": 67.11,
		"purchasing_index": 133.08
	},
	"Zaragoza (Saragossa), Spain": {
		"slug": "",
		"currency_type": "EUR",
		"index": 39.27,
		"rent_index": 14.95,
		"groceries_index": 51.12,
		"restaurant_index": 53.51,
		"purchasing_index": 79.34
	},
	"Bari, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 39.43,
		"rent_index": 15.34,
		"groceries_index": 50.71,
		"restaurant_index": 61.29,
		"purchasing_index": 60.57
	},
	"Palermo, Italy": {
		"slug": "",
		"currency_type": "EUR",
		"index": 39.24,
		"rent_index": 14.98,
		"groceries_index": 53.1,
		"restaurant_index": 57.39,
		"purchasing_index": 61.56
	},
	"Springfield, MO, United States": {
		"slug": "",
		"currency_type": "USD",
		"index": 41.09,
		"rent_index": 18.88,
		"groceries_index": 65.27,
		"restaurant_index": 56.36,
		"purchasing_index": 88.45
	},
	"Hamilton, Canada": {
		"slug": "",
		"currency_type": "CAD",
		"index": 43.74,
		"rent_index": 24.43,
		"groceries_index": 55.89,
		"restaurant_index": 58.52,
		"purchasing_index": 130.23
	},
	"Nicosia, Cyprus": {
		"slug": "nicosia",
		"currency_type": "EUR",
		"index": 38.85,
		"rent_index": 14.55,
		"groceries_index": 52.72,
		"restaurant_index": 69.18,
		"purchasing_index": 91.25
	},
	"Male, Maldives": {
		"slug": "",
		"currency_type": "MVR",
		"index": 47.25,
		"rent_index": 32.14,
		"groceries_index": 60.5,
		"restaurant_index": 42.75,
		"purchasing_index": 28.96
	},
	"Barcelona, Spain": {
		"slug": "barcelona",
		"currency_type": "EUR",
		"index": 44.66,
		"rent_index": 26.76,
		"groceries_index": 50.37,
		"restaurant_index": 57.18,
		"purchasing_index": 83.1
	},
	"Irbil, Iraq": {
		"slug": "",
		"currency_type": "IQD",
		"index": 40.65,
		"rent_index": 18.46,
		"groceries_index": 43.8,
		"restaurant_index": 59.22,
		"purchasing_index": 41.28
	},
	"Madrid, Spain": {
		"slug": "madrid",
		"currency_type": "EUR",
		"index": 45.06,
		"rent_index": 28.29,
		"groceries_index": 49.67,
		"restaurant_index": 60.28,
		"purchasing_index": 85.18
	},
	"Dresden, Germany": {
		"slug": "dresden",
		"currency_type": "EUR",
		"index": 40.46,
		"rent_index": 18.86,
		"groceries_index": 46.1,
		"restaurant_index": 49.38,
		"purchasing_index": 122.83
	},
	"Belfast, United Kingdom": {
		"slug": "belfast",
		"currency_type": "GBP",
		"index": 40.94,
		"rent_index": 20.17,
		"groceries_index": 54.61,
		"restaurant_index": 66.29,
		"purchasing_index": 119.46
	},
	"Bremen, Germany": {
		"slug": "",
		"currency_type": "EUR",
		"index": 40.71,
		"rent_index": 19.81,
		"groceries_index": 41.26,
		"restaurant_index": 62.16,
		"purchasing_index": 149.81
	},
	"Palma De Mallorca, Spain": {
		"slug": "",
		"currency_type": "EUR",
		"index": 40.62,
		"rent_index": 19.87,
		"groceries_index": 48.52,
		"restaurant_index": 59.45,
		"purchasing_index": 80.41
	},
	"Campinas, Brazil": {
		"slug": "",
		"currency_type": "BRL",
		"index": 38.34,
		"rent_index": 15.64,
		"groceries_index": 45.75,
		"restaurant_index": 45.65,
		"purchasing_index": 54.48
	},
	"Aachen, Germany": {
		"slug": "",
		"currency_type": "EUR",
		"index": 40.77,
		"rent_index": 20.97,
		"groceries_index": 46.6,
		"restaurant_index": 57.14,
		"purchasing_index": 152.5
	},
	"Ljubljana, Slovenia": {
		"slug": "ljubljana",
		"currency_type": "EUR",
		"index": 39.07,
		"rent_index": 17.71,
		"groceries_index": 48.18,
		"restaurant_index": 48.7,
		"purchasing_index": 72.23
	},
	"Athens, Greece": {
		"slug": "athens",
		"currency_type": "EUR",
		"index": 36.22,
		"rent_index": 11.89,
		"groceries_index": 46.86,
		"restaurant_index": 60.73,
		"purchasing_index": 51.3
	},
	"Manama, Bahrain": {
		"slug": "",
		"currency_type": "BHD",
		"index": 45.17,
		"rent_index": 30.88,
		"groceries_index": 53.67,
		"restaurant_index": 52.36,
		"purchasing_index": 101.2
	},
	"Rio De Janeiro, Brazil": {
		"slug": "rio-de-janeiro",
		"currency_type": "BRL",
		"index": 42.2,
		"rent_index": 24.92,
		"groceries_index": 44.83,
		"restaurant_index": 51.65,
		"purchasing_index": 43.26
	},
	"Sao Paulo, Brazil": {
		"slug": "sao-paulo",
		"currency_type": "BRL",
		"index": 40.5,
		"rent_index": 21.64,
		"groceries_index": 45.16,
		"restaurant_index": 49.64,
		"purchasing_index": 42.51
	},
	"Ulaanbaatar, Mongolia": {
		"slug": "",
		"currency_type": "MNT",
		"index": 44.05,
		"rent_index": 29.77,
		"groceries_index": 56.68,
		"restaurant_index": 31.5,
		"purchasing_index": 22.36
	},
	"Limassol, Cyprus": {
		"slug": "",
		"currency_type": "EUR",
		"index": 37.58,
		"rent_index": 16.61,
		"groceries_index": 46.65,
		"restaurant_index": 61.27,
		"purchasing_index": 103.73
	},
	"Dar Es Salaam, Tanzania": {
		"slug": "dar-es-salaam",
		"currency_type": "TZS",
		"index": 44.73,
		"rent_index": 32.27,
		"groceries_index": 43.1,
		"restaurant_index": 37.11,
		"purchasing_index": 25.27
	},
	"Brasilia, Brazil": {
		"slug": "",
		"currency_type": "BRL",
		"index": 37,
		"rent_index": 16.3,
		"groceries_index": 45.24,
		"restaurant_index": 47.34,
		"purchasing_index": 48.71
	},
	"Thessaloniki, Greece": {
		"slug": "thessaloniki",
		"currency_type": "EUR",
		"index": 33.95,
		"rent_index": 10.12,
		"groceries_index": 43.44,
		"restaurant_index": 54.81,
		"purchasing_index": 50.44
	},
	"Heraklion, Greece": {
		"slug": "",
		"currency_type": "EUR",
		"index": 33.01,
		"rent_index": 9.29,
		"groceries_index": 47.03,
		"restaurant_index": 49.32,
		"purchasing_index": 67.56
	},
	"Buenos Aires, Argentina": {
		"slug": "buenos-aires",
		"currency_type": "ARS",
		"index": 35.72,
		"rent_index": 15.06,
		"groceries_index": 45.89,
		"restaurant_index": 53.49,
		"purchasing_index": 56.86
	},
	"Shanghai, China": {
		"slug": "shanghai",
		"currency_type": "CNY",
		"index": 46,
		"rent_index": 36.85,
		"groceries_index": 57.72,
		"restaurant_index": 40,
		"purchasing_index": 74.16
	},
	"Muscat, Oman": {
		"slug": "",
		"currency_type": "OMI",
		"index": 43.93,
		"rent_index": 32.58,
		"groceries_index": 48.91,
		"restaurant_index": 59.17,
		"purchasing_index": 119.41
	},
	"Kaohsiung, Taiwan": {
		"slug": "",
		"currency_type": "TWD",
		"index": 33.07,
		"rent_index": 10.37,
		"groceries_index": 61.72,
		"restaurant_index": 23.02,
		"purchasing_index": 144.45
	},
	"Santo Domingo, Dominican Republic": {
		"slug": "santo-domingo",
		"currency_type": "DOP",
		"index": 34.43,
		"rent_index": 13.57,
		"groceries_index": 47.75,
		"restaurant_index": 43.78,
		"purchasing_index": 25.81
	},
	"Santiago, Chile": {
		"slug": "santiago",
		"currency_type": "CLP",
		"index": 36.54,
		"rent_index": 18,
		"groceries_index": 46.98,
		"restaurant_index": 51.45,
		"purchasing_index": 56.32
	},
	"Shenzhen, China": {
		"slug": "",
		"currency_type": "CNY",
		"index": 42.07,
		"rent_index": 29.6,
		"groceries_index": 58.43,
		"restaurant_index": 34,
		"purchasing_index": 74.75
	},
	"Granada, Spain": {
		"slug": "",
		"currency_type": "EUR",
		"index": 34.03,
		"rent_index": 13.14,
		"groceries_index": 44.75,
		"restaurant_index": 49.48,
		"purchasing_index": 88.48
	},
	"Alicante, Spain": {
		"slug": "",
		"currency_type": "EUR",
		"index": 34.82,
		"rent_index": 14.81,
		"groceries_index": 43.3,
		"restaurant_index": 48.25,
		"purchasing_index": 76.14
	},
	"Makati, Philippines": {
		"slug": "",
		"currency_type": "PHP",
		"index": 40.83,
		"rent_index": 27.74,
		"groceries_index": 54.2,
		"restaurant_index": 33.23,
		"purchasing_index": 42.67
	},
	"Porto Alegre, Brazil": {
		"slug": "porto-alegre",
		"currency_type": "BRL",
		"index": 34.01,
		"rent_index": 13.61,
		"groceries_index": 41.68,
		"restaurant_index": 42.52,
		"purchasing_index": 47.52
	},
	"Valencia, Spain": {
		"slug": "valencia",
		"currency_type": "EUR",
		"index": 35.57,
		"rent_index": 16.88,
		"groceries_index": 44.23,
		"restaurant_index": 48.76,
		"purchasing_index": 87.46
	},
	"Harare, Zimbabwe": {
		"slug": "",
		"currency_type": "ZWL",
		"index": 34.68,
		"rent_index": 15.37,
		"groceries_index": 42.5,
		"restaurant_index": 42.3,
		"purchasing_index": 26.5
	},
	"Patras, Greece": {
		"slug": "",
		"currency_type": "EUR",
		"index": 31.45,
		"rent_index": 8.88,
		"groceries_index": 41.11,
		"restaurant_index": 54.06,
		"purchasing_index": 66.56
	},
	"Recife, Brazil": {
		"slug": "",
		"currency_type": "BRL",
		"index": 33.42,
		"rent_index": 13.91,
		"groceries_index": 43.81,
		"restaurant_index": 34.06,
		"purchasing_index": 34.46
	},
	"Tallinn, Estonia": {
		"slug": "tallinn",
		"currency_type": "EUR",
		"index": 34.1,
		"rent_index": 15.33,
		"groceries_index": 37.57,
		"restaurant_index": 53.13,
		"purchasing_index": 68.76
	},
	"Guayaquil, Ecuador": {
		"slug": "",
		"currency_type": "USD",
		"index": 33.37,
		"rent_index": 13.92,
		"groceries_index": 45.91,
		"restaurant_index": 38.06,
		"purchasing_index": 36.14
	},
	"Rijeka, Croatia": {
		"slug": "",
		"currency_type": "HRK",
		"index": 32.01,
		"rent_index": 11.18,
		"groceries_index": 43.01,
		"restaurant_index": 39.17,
		"purchasing_index": 49.26
	},
	"Florianopolis, Brazil": {
		"slug": "florianopolis",
		"currency_type": "BRL",
		"index": 33.63,
		"rent_index": 14.79,
		"groceries_index": 40.14,
		"restaurant_index": 41.55,
		"purchasing_index": 41.16
	},
	"Split, Croatia": {
		"slug": "",
		"currency_type": "HRK",
		"index": 31.89,
		"rent_index": 11.47,
		"groceries_index": 42.84,
		"restaurant_index": 46.46,
		"purchasing_index": 53.35
	},
	"Belo Horizonte, Brazil": {
		"slug": "",
		"currency_type": "BRL",
		"index": 32.91,
		"rent_index": 13.68,
		"groceries_index": 40.77,
		"restaurant_index": 35.9,
		"purchasing_index": 39.56
	},
	"Lisbon, Portugal": {
		"slug": "lisbon",
		"currency_type": "EUR",
		"index": 37.07,
		"rent_index": 22.51,
		"groceries_index": 40.17,
		"restaurant_index": 44.23,
		"purchasing_index": 61.33
	},
	"Phnom Penh, Cambodia": {
		"slug": "phnom-penh",
		"currency_type": "KHR",
		"index": 35.73,
		"rent_index": 19.9,
		"groceries_index": 54.21,
		"restaurant_index": 24.36,
		"purchasing_index": 20.61
	},
	"Jeddah (Jiddah), Saudi Arabia": {
		"slug": "",
		"currency_type": "SAR",
		"index": 33.27,
		"rent_index": 15.02,
		"groceries_index": 41.3,
		"restaurant_index": 31.86,
		"purchasing_index": 111.99
	},
	"Curitiba, Brazil": {
		"slug": "curitiba",
		"currency_type": "BRL",
		"index": 31.67,
		"rent_index": 12.05,
		"groceries_index": 38.19,
		"restaurant_index": 41.35,
		"purchasing_index": 50.73
	},
	"Malaga, Spain": {
		"slug": "malaga",
		"currency_type": "EUR",
		"index": 34.49,
		"rent_index": 17.97,
		"groceries_index": 41.21,
		"restaurant_index": 45.06,
		"purchasing_index": 104.23
	},
	"Bangkok, Thailand": {
		"slug": "bangkok",
		"currency_type": "THB",
		"index": 37.64,
		"rent_index": 24.59,
		"groceries_index": 54.03,
		"restaurant_index": 25.95,
		"purchasing_index": 49.07
	},
	"Seville, Spain": {
		"slug": "seville",
		"currency_type": "EUR",
		"index": 34.74,
		"rent_index": 18.53,
		"groceries_index": 41.35,
		"restaurant_index": 46.19,
		"purchasing_index": 82.5
	},
	"Phuket, Thailand": {
		"slug": "phuket",
		"currency_type": "THB",
		"index": 32.27,
		"rent_index": 13.58,
		"groceries_index": 54.51,
		"restaurant_index": 25.16,
		"purchasing_index": 46.36
	},
	"Riga, Latvia": {
		"slug": "riga",
		"currency_type": "EUR",
		"index": 31.79,
		"rent_index": 12.87,
		"groceries_index": 36.58,
		"restaurant_index": 45.58,
		"purchasing_index": 52.01
	},
	"Tripoli, Libya": {
		"slug": "",
		"currency_type": "LYD",
		"index": 35.11,
		"rent_index": 19.85,
		"groceries_index": 47.78,
		"restaurant_index": 34.5,
		"purchasing_index": 51.78
	},
	"Beijing, China": {
		"slug": "beijing",
		"currency_type": "CNY",
		"index": 43.78,
		"rent_index": 38.2,
		"groceries_index": 47.83,
		"restaurant_index": 37.85,
		"purchasing_index": 70.92
	},
	"Porto, Portugal": {
		"slug": "porto",
		"currency_type": "EUR",
		"index": 33.04,
		"rent_index": 15.99,
		"groceries_index": 39.25,
		"restaurant_index": 38.73,
		"purchasing_index": 66.31
	},
	"Zagreb, Croatia": {
		"slug": "zagreb",
		"currency_type": "HRK",
		"index": 31.06,
		"rent_index": 12.03,
		"groceries_index": 41.19,
		"restaurant_index": 37.82,
		"purchasing_index": 67.14
	},
	"Jakarta, Indonesia": {
		"slug": "jakarta",
		"currency_type": "IDR",
		"index": 36.41,
		"rent_index": 23.34,
		"groceries_index": 52.41,
		"restaurant_index": 27.1,
		"purchasing_index": 41.45
	},
	"Quito, Ecuador": {
		"slug": "quito",
		"currency_type": "USD",
		"index": 32.39,
		"rent_index": 15.05,
		"groceries_index": 46.95,
		"restaurant_index": 34.61,
		"purchasing_index": 34.49
	},
	"Tartu, Estonia": {
		"slug": "tartu",
		"currency_type": "EUR",
		"index": 31.68,
		"rent_index": 13.71,
		"groceries_index": 37.05,
		"restaurant_index": 48.43,
		"purchasing_index": 73.46
	},
	"San Salvador, El Salvador": {
		"slug": "san-salvador",
		"currency_type": "USD",
		"index": 29.93,
		"rent_index": 10.25,
		"groceries_index": 43.9,
		"restaurant_index": 37.8,
		"purchasing_index": 28.88
	},
	"Al Khobar, Saudi Arabia": {
		"slug": "",
		"currency_type": "SAR",
		"index": 32.58,
		"rent_index": 15.8,
		"groceries_index": 42.44,
		"restaurant_index": 32.42,
		"purchasing_index": 156.36
	},
	"Moscow, Russia": {
		"slug": "moscow",
		"currency_type": "RUB",
		"index": 39.6,
		"rent_index": 30.68,
		"groceries_index": 36.95,
		"restaurant_index": 52.6,
		"purchasing_index": 57.38
	},
	"Riyadh, Saudi Arabia": {
		"slug": "riyadh",
		"currency_type": "SAR",
		"index": 32.74,
		"rent_index": 16.38,
		"groceries_index": 40.84,
		"restaurant_index": 33.76,
		"purchasing_index": 148.29
	},
	"Bratislava, Slovakia": {
		"slug": "bratislava",
		"currency_type": "EUR",
		"index": 34.19,
		"rent_index": 19.62,
		"groceries_index": 42.31,
		"restaurant_index": 35.58,
		"purchasing_index": 70.94
	},
	"Coimbra, Portugal": {
		"slug": "",
		"currency_type": "EUR",
		"index": 31.06,
		"rent_index": 13.17,
		"groceries_index": 38.36,
		"restaurant_index": 38.07,
		"purchasing_index": 69.37
	},
	"Vilnius, Lithuania": {
		"slug": "vilnius",
		"currency_type": "EUR",
		"index": 31.72,
		"rent_index": 14.86,
		"groceries_index": 36.32,
		"restaurant_index": 40.39,
		"purchasing_index": 54.06
	},
	"Addis Ababa, Ethiopia": {
		"slug": "",
		"currency_type": "ETB",
		"index": 34.46,
		"rent_index": 20.83,
		"groceries_index": 39.7,
		"restaurant_index": 23.91,
		"purchasing_index": 15.54
	},
	"Braga, Portugal": {
		"slug": "",
		"currency_type": "EUR",
		"index": 29.59,
		"rent_index": 11.41,
		"groceries_index": 37.34,
		"restaurant_index": 32.98,
		"purchasing_index": 64.02
	},
	"Kaunas, Lithuania": {
		"slug": "",
		"currency_type": "EUR",
		"index": 28.87,
		"rent_index": 10.05,
		"groceries_index": 35.96,
		"restaurant_index": 40.51,
		"purchasing_index": 50.05
	},
	"Cuenca, Ecuador": {
		"slug": "",
		"currency_type": "USD",
		"index": 29.42,
		"rent_index": 11.3,
		"groceries_index": 48.35,
		"restaurant_index": 31.66,
		"purchasing_index": 38.65
	},
	"Guatemala City, Guatemala": {
		"slug": "guatemala-city",
		"currency_type": "GTQ",
		"index": 31.8,
		"rent_index": 16.46,
		"groceries_index": 41.46,
		"restaurant_index": 35.61,
		"purchasing_index": 48.23
	},
	"Kota Kinabalu, Malaysia": {
		"slug": "",
		"currency_type": "MYR",
		"index": 27.79,
		"rent_index": 8.26,
		"groceries_index": 50.88,
		"restaurant_index": 22.21,
		"purchasing_index": 46.28
	},
	"Guangzhou, China": {
		"slug": "",
		"currency_type": "CNY",
		"index": 33.51,
		"rent_index": 20.48,
		"groceries_index": 45.99,
		"restaurant_index": 28.28,
		"purchasing_index": 69.89
	},
	"Kosice, Slovakia": {
		"slug": "",
		"currency_type": "EUR",
		"index": 30.41,
		"rent_index": 14.49,
		"groceries_index": 40.77,
		"restaurant_index": 27.74,
		"purchasing_index": 56.05
	},
	"Johannesburg, South Africa": {
		"slug": "johannesburg",
		"currency_type": "ZAR",
		"index": 32.05,
		"rent_index": 17.99,
		"groceries_index": 37.59,
		"restaurant_index": 40.29,
		"purchasing_index": 111.67
	},
	"Bali, Indonesia": {
		"slug": "bali",
		"currency_type": "IDR",
		"index": 30.07,
		"rent_index": 14.04,
		"groceries_index": 49.56,
		"restaurant_index": 24.13,
		"purchasing_index": 19.61
	},
	"Saint Petersburg, Russia": {
		"slug": "saint-petersburg",
		"currency_type": "RUB",
		"index": 32.46,
		"rent_index": 19.49,
		"groceries_index": 35.07,
		"restaurant_index": 44.88,
		"purchasing_index": 50.13
	},
	"Cape Town, South Africa": {
		"slug": "cape-town",
		"currency_type": "ZAR",
		"index": 35.07,
		"rent_index": 25.31,
		"groceries_index": 37.03,
		"restaurant_index": 40.59,
		"purchasing_index": 86.13
	},
	"Budapest, Hungary": {
		"slug": "budapest",
		"currency_type": "HUF",
		"index": 30.04,
		"rent_index": 14.97,
		"groceries_index": 34.41,
		"restaurant_index": 33.08,
		"purchasing_index": 52.33
	},
	"Prague, Czech Republic": {
		"slug": "prague",
		"currency_type": "CZK",
		"index": 31.92,
		"rent_index": 19.2,
		"groceries_index": 37.77,
		"restaurant_index": 31.44,
		"purchasing_index": 76.62
	},
	"Chiang Mai, Thailand": {
		"slug": "chiang-mai",
		"currency_type": "THB",
		"index": 28.4,
		"rent_index": 11.97,
		"groceries_index": 53.91,
		"restaurant_index": 20.1,
		"purchasing_index": 32.38
	},
	"Pattaya, Thailand": {
		"slug": "",
		"currency_type": "THB",
		"index": 30.05,
		"rent_index": 15.64,
		"groceries_index": 49.04,
		"restaurant_index": 24.67,
		"purchasing_index": 26.07
	},
	"Ho Chi Minh City, Vietnam": {
		"slug": "ho-chi-minh-city",
		"currency_type": "VND",
		"index": 30.98,
		"rent_index": 17.61,
		"groceries_index": 45.26,
		"restaurant_index": 21.01,
		"purchasing_index": 32.45
	},
	"Lima, Peru": {
		"slug": "lima",
		"currency_type": "PEN",
		"index": 31.87,
		"rent_index": 19.77,
		"groceries_index": 39.47,
		"restaurant_index": 31,
		"purchasing_index": 44.44
	},
	"Penang, Malaysia": {
		"slug": "",
		"currency_type": "MYR",
		"index": 27.04,
		"rent_index": 9.8,
		"groceries_index": 47.29,
		"restaurant_index": 22.96,
		"purchasing_index": 72.54
	},
	"Kuala Lumpur, Malaysia": {
		"slug": "kuala-lumpur",
		"currency_type": "MYR",
		"index": 30.33,
		"rent_index": 16.72,
		"groceries_index": 44.83,
		"restaurant_index": 24.79,
		"purchasing_index": 81.35
	},
	"Osijek, Croatia": {
		"slug": "",
		"currency_type": "HRK",
		"index": 25.61,
		"rent_index": 6.94,
		"groceries_index": 36.6,
		"restaurant_index": 28.67,
		"purchasing_index": 58.63
	},
	"Lagos, Nigeria": {
		"slug": "lagos",
		"currency_type": "NGN",
		"index": 31.44,
		"rent_index": 19.38,
		"groceries_index": 38.63,
		"restaurant_index": 23.1,
		"purchasing_index": 29.76
	},
	"Nairobi, Kenya": {
		"slug": "nairobi",
		"currency_type": "KES",
		"index": 28.87,
		"rent_index": 14.17,
		"groceries_index": 39.84,
		"restaurant_index": 34.47,
		"purchasing_index": 28.64
	},
	"Hanoi, Vietnam": {
		"slug": "",
		"currency_type": "VND",
		"index": 30.48,
		"rent_index": 17.6,
		"groceries_index": 38.77,
		"restaurant_index": 23.59,
		"purchasing_index": 21.85
	},
	"Tehran, Iran": {
		"slug": "tehran",
		"currency_type": "IRR",
		"index": 32.35,
		"rent_index": 21.71,
		"groceries_index": 37.74,
		"restaurant_index": 33.82,
		"purchasing_index": 39.85
	},
	"Istanbul, Turkey": {
		"slug": "istanbul",
		"currency_type": "TRY",
		"index": 28.54,
		"rent_index": 14.4,
		"groceries_index": 35.67,
		"restaurant_index": 30.66,
		"purchasing_index": 55.18
	},
	"Kigali, Rwanda": {
		"slug": "",
		"currency_type": "RWF",
		"index": 28.08,
		"rent_index": 13.68,
		"groceries_index": 32.73,
		"restaurant_index": 28.2,
		"purchasing_index": 27.31
	},
	"Rabat, Morocco": {
		"slug": "",
		"currency_type": "MAD",
		"index": 27.37,
		"rent_index": 12.28,
		"groceries_index": 36.74,
		"restaurant_index": 25.45,
		"purchasing_index": 37.03
	},
	"Johor Bahru, Malaysia": {
		"slug": "",
		"currency_type": "MYR",
		"index": 27,
		"rent_index": 11.6,
		"groceries_index": 48.25,
		"restaurant_index": 18.26,
		"purchasing_index": 54.63
	},
	"Brno, Czech Republic": {
		"slug": "brno",
		"currency_type": "CZK",
		"index": 28.38,
		"rent_index": 14.5,
		"groceries_index": 36.22,
		"restaurant_index": 27.24,
		"purchasing_index": 75.76
	},
	"Selangor, Malaysia": {
		"slug": "",
		"currency_type": "MYR",
		"index": 25.99,
		"rent_index": 9.6,
		"groceries_index": 47.41,
		"restaurant_index": 17.72,
		"purchasing_index": 89.4
	},
	"Durban, South Africa": {
		"slug": "",
		"currency_type": "ZAR",
		"index": 28.28,
		"rent_index": 14.52,
		"groceries_index": 34.05,
		"restaurant_index": 37.64,
		"purchasing_index": 98.38
	},
	"Warsaw, Poland": {
		"slug": "warsaw",
		"currency_type": "PLN",
		"index": 30.16,
		"rent_index": 18.62,
		"groceries_index": 31.51,
		"restaurant_index": 35.14,
		"purchasing_index": 74.32
	},
	"Manila, Philippines": {
		"slug": "manila",
		"currency_type": "PHP",
		"index": 28.67,
		"rent_index": 15.9,
		"groceries_index": 37.58,
		"restaurant_index": 24.57,
		"purchasing_index": 47.8
	},
	"Cebu, Philippines": {
		"slug": "",
		"currency_type": "PHP",
		"index": 26.79,
		"rent_index": 12.16,
		"groceries_index": 39.56,
		"restaurant_index": 25.28,
		"purchasing_index": 23.37
	},
	"Gdansk, Poland": {
		"slug": "gdansk",
		"currency_type": "PLN",
		"index": 27.11,
		"rent_index": 14.13,
		"groceries_index": 28.7,
		"restaurant_index": 32.05,
		"purchasing_index": 72.08
	},
	"Podgorica, Montenegro": {
		"slug": "",
		"currency_type": "EUR",
		"index": 25.74,
		"rent_index": 11.33,
		"groceries_index": 30.87,
		"restaurant_index": 32.49,
		"purchasing_index": 49.61
	},
	"Caracas, Venezuela": {
		"slug": "caracas",
		"currency_type": "VEF",
		"index": 24.76,
		"rent_index": 9.46,
		"groceries_index": 39.22,
		"restaurant_index": 38.6,
		"purchasing_index": 2.99
	},
	"Yekaterinburg, Russia": {
		"slug": "",
		"currency_type": "RUB",
		"index": 26.07,
		"rent_index": 12.29,
		"groceries_index": 32.85,
		"restaurant_index": 35.41,
		"purchasing_index": 50.08
	},
	"Krakow (Cracow), Poland": {
		"slug": "krakow",
		"currency_type": "PLN",
		"index": 27.53,
		"rent_index": 15.53,
		"groceries_index": 30.31,
		"restaurant_index": 31.61,
		"purchasing_index": 73.94
	},
	"Bucharest, Romania": {
		"slug": "bucharest",
		"currency_type": "RON",
		"index": 25.87,
		"rent_index": 12.1,
		"groceries_index": 30.99,
		"restaurant_index": 35.08,
		"purchasing_index": 53.59
	},
	"Olomouc, Czech Republic": {
		"slug": "",
		"currency_type": "CZK",
		"index": 25.39,
		"rent_index": 11.12,
		"groceries_index": 36.49,
		"restaurant_index": 26.3,
		"purchasing_index": 78.28
	},
	"Gdynia, Poland": {
		"slug": "",
		"currency_type": "PLN",
		"index": 25.67,
		"rent_index": 11.72,
		"groceries_index": 30.32,
		"restaurant_index": 30.48,
		"purchasing_index": 70.51
	},
	"Wroclaw, Poland": {
		"slug": "wroclaw",
		"currency_type": "PLN",
		"index": 27.52,
		"rent_index": 15.73,
		"groceries_index": 30.98,
		"restaurant_index": 31.63,
		"purchasing_index": 69.21
	},
	"Bogota, Colombia": {
		"slug": "bogota",
		"currency_type": "COP",
		"index": 26.92,
		"rent_index": 14.53,
		"groceries_index": 32.87,
		"restaurant_index": 28.2,
		"purchasing_index": 36.69
	},
	"Colombo, Sri Lanka": {
		"slug": "",
		"currency_type": "LKR",
		"index": 25.76,
		"rent_index": 12.2,
		"groceries_index": 39.76,
		"restaurant_index": 21.55,
		"purchasing_index": 24.88
	},
	"Ostrava, Czech Republic": {
		"slug": "",
		"currency_type": "CZK",
		"index": 24.49,
		"rent_index": 9.72,
		"groceries_index": 33.76,
		"restaurant_index": 27.37,
		"purchasing_index": 74.91
	},
	"Kazan, Russia": {
		"slug": "",
		"currency_type": "RUB",
		"index": 25.31,
		"rent_index": 11.68,
		"groceries_index": 30.78,
		"restaurant_index": 42.91,
		"purchasing_index": 47.54
	},
	"Poznan, Poland": {
		"slug": "",
		"currency_type": "PLN",
		"index": 25.94,
		"rent_index": 13.09,
		"groceries_index": 31.24,
		"restaurant_index": 31.61,
		"purchasing_index": 66.8
	},
	"Sofia, Bulgaria": {
		"slug": "sofia",
		"currency_type": "BGN",
		"index": 24.67,
		"rent_index": 10.56,
		"groceries_index": 31.9,
		"restaurant_index": 29.78,
		"purchasing_index": 57.21
	},
	"Sarajevo, Bosnia And Herzegovina": {
		"slug": "sarajevo",
		"currency_type": "BAM",
		"index": 23.41,
		"rent_index": 7.95,
		"groceries_index": 31.14,
		"restaurant_index": 27.63,
		"purchasing_index": 48.9
	},
	"Bandung, Indonesia": {
		"slug": "",
		"currency_type": "IDR",
		"index": 23.18,
		"rent_index": 7.77,
		"groceries_index": 44.19,
		"restaurant_index": 16.71,
		"purchasing_index": 23.91
	},
	"Ankara, Turkey": {
		"slug": "ankara",
		"currency_type": "TRY",
		"index": 22.93,
		"rent_index": 7.29,
		"groceries_index": 33.25,
		"restaurant_index": 26.48,
		"purchasing_index": 62
	},
	"Dhaka, Bangladesh": {
		"slug": "",
		"currency_type": "BDT",
		"index": 22.65,
		"rent_index": 6.73,
		"groceries_index": 33.04,
		"restaurant_index": 26.54,
		"purchasing_index": 38.59
	},
	"Szczecin, Poland": {
		"slug": "",
		"currency_type": "PLN",
		"index": 24.54,
		"rent_index": 10.68,
		"groceries_index": 29.52,
		"restaurant_index": 28.57,
		"purchasing_index": 62.05
	},
	"Lodz, Poland": {
		"slug": "",
		"currency_type": "PLN",
		"index": 24.65,
		"rent_index": 11.3,
		"groceries_index": 28.89,
		"restaurant_index": 30.74,
		"purchasing_index": 67.82
	},
	"Cluj-napoca, Romania": {
		"slug": "cluj-napoca",
		"currency_type": "RON",
		"index": 24.49,
		"rent_index": 11.1,
		"groceries_index": 31.61,
		"restaurant_index": 28.8,
		"purchasing_index": 51.76
	},
	"Casablanca, Morocco": {
		"slug": "casablanca",
		"currency_type": "MAD",
		"index": 25.62,
		"rent_index": 13.45,
		"groceries_index": 33.3,
		"restaurant_index": 24.55,
		"purchasing_index": 48.09
	},
	"Antalya, Turkey": {
		"slug": "",
		"currency_type": "TRY",
		"index": 22.26,
		"rent_index": 6.48,
		"groceries_index": 33.11,
		"restaurant_index": 27.31,
		"purchasing_index": 64.01
	},
	"Algiers, Algeria": {
		"slug": "",
		"currency_type": "DZD",
		"index": 23.51,
		"rent_index": 9.61,
		"groceries_index": 36.12,
		"restaurant_index": 26.18,
		"purchasing_index": 35.49
	},
	"Belgrade, Serbia": {
		"slug": "belgrade",
		"currency_type": "RSD",
		"index": 23.69,
		"rent_index": 10.01,
		"groceries_index": 26.39,
		"restaurant_index": 32.63,
		"purchasing_index": 40.31
	},
	"Izmir, Turkey": {
		"slug": "",
		"currency_type": "TRY",
		"index": 22.64,
		"rent_index": 7.97,
		"groceries_index": 31.04,
		"restaurant_index": 26.38,
		"purchasing_index": 54.23
	},
	"Plovdiv, Bulgaria": {
		"slug": "",
		"currency_type": "BGN",
		"index": 21.77,
		"rent_index": 6.26,
		"groceries_index": 30.27,
		"restaurant_index": 31.04,
		"purchasing_index": 44.51
	},
	"Lublin, Poland": {
		"slug": "",
		"currency_type": "PLN",
		"index": 25.09,
		"rent_index": 13.31,
		"groceries_index": 27.86,
		"restaurant_index": 26.98,
		"purchasing_index": 59.66
	},
	"Varna, Bulgaria": {
		"slug": "",
		"currency_type": "BGN",
		"index": 22.35,
		"rent_index": 7.84,
		"groceries_index": 31.04,
		"restaurant_index": 29.67,
		"purchasing_index": 44.9
	},
	"Novosibirsk, Russia": {
		"slug": "",
		"currency_type": "RUB",
		"index": 24.04,
		"rent_index": 11.53,
		"groceries_index": 32.08,
		"restaurant_index": 30.18,
		"purchasing_index": 48.3
	},
	"Timisoara, Romania": {
		"slug": "",
		"currency_type": "RON",
		"index": 23.04,
		"rent_index": 9.64,
		"groceries_index": 29.76,
		"restaurant_index": 26.95,
		"purchasing_index": 49.71
	},
	"Bursa, Turkey": {
		"slug": "",
		"currency_type": "TRY",
		"index": 21.28,
		"rent_index": 6.02,
		"groceries_index": 31.11,
		"restaurant_index": 23.75,
		"purchasing_index": 67.07
	},
	"Katowice, Poland": {
		"slug": "",
		"currency_type": "PLN",
		"index": 23.33,
		"rent_index": 10.32,
		"groceries_index": 28.61,
		"restaurant_index": 27.3,
		"purchasing_index": 79.66
	},
	"Quezon City, Philippines": {
		"slug": "",
		"currency_type": "PHP",
		"index": 21.85,
		"rent_index": 7.23,
		"groceries_index": 32.24,
		"restaurant_index": 19.65,
		"purchasing_index": 40.96
	},
	"Sibiu, Romania": {
		"slug": "",
		"currency_type": "RON",
		"index": 21.95,
		"rent_index": 7.64,
		"groceries_index": 29.22,
		"restaurant_index": 28.04,
		"purchasing_index": 42.18
	},
	"Minsk, Belarus": {
		"slug": "minsk",
		"currency_type": "BYR",
		"index": 24.11,
		"rent_index": 12.56,
		"groceries_index": 28.24,
		"restaurant_index": 37.93,
		"purchasing_index": 36.44
	},
	"Banja Luka, Bosnia And Herzegovina": {
		"slug": "",
		"currency_type": "BAM",
		"index": 21.14,
		"rent_index": 6.4,
		"groceries_index": 28.49,
		"restaurant_index": 24.14,
		"purchasing_index": 51.23
	},
	"Yerevan, Armenia": {
		"slug": "yerevan",
		"currency_type": "AMD",
		"index": 23.25,
		"rent_index": 10.91,
		"groceries_index": 26.61,
		"restaurant_index": 32.44,
		"purchasing_index": 33.28
	},
	"Skopje, Macedonia": {
		"slug": "skopje",
		"currency_type": "MKD",
		"index": 21.87,
		"rent_index": 8.12,
		"groceries_index": 27.77,
		"restaurant_index": 26.06,
		"purchasing_index": 39.69
	},
	"Islamabad, Pakistan": {
		"slug": "",
		"currency_type": "PKR",
		"index": 22.48,
		"rent_index": 9.62,
		"groceries_index": 31.63,
		"restaurant_index": 22.74,
		"purchasing_index": 35.05
	},
	"Novi Sad, Serbia": {
		"slug": "",
		"currency_type": "RSD",
		"index": 20.92,
		"rent_index": 6.42,
		"groceries_index": 25.68,
		"restaurant_index": 26.85,
		"purchasing_index": 39.33
	},
	"Asuncion, Paraguay": {
		"slug": "asuncion",
		"currency_type": "PYG",
		"index": 22.48,
		"rent_index": 9.87,
		"groceries_index": 28.17,
		"restaurant_index": 26.11,
		"purchasing_index": 38.78
	},
	"Brasov, Romania": {
		"slug": "",
		"currency_type": "RON",
		"index": 21.65,
		"rent_index": 8.18,
		"groceries_index": 27.47,
		"restaurant_index": 29.65,
		"purchasing_index": 58.6
	},
	"Medellin, Colombia": {
		"slug": "medellin",
		"currency_type": "COP",
		"index": 21.48,
		"rent_index": 7.97,
		"groceries_index": 30.23,
		"restaurant_index": 24.06,
		"purchasing_index": 37.96
	},
	"Iasi, Romania": {
		"slug": "",
		"currency_type": "RON ",
		"index": 21.95,
		"rent_index": 9,
		"groceries_index": 27.62,
		"restaurant_index": 27.22,
		"purchasing_index": 49.63
	},
	"Mexico City, Mexico": {
		"slug": "mexico-city",
		"currency_type": "MXN",
		"index": 24.96,
		"rent_index": 15.58,
		"groceries_index": 31.39,
		"restaurant_index": 29.8,
		"purchasing_index": 58.17
	},
	"Tirana, Albania": {
		"slug": "",
		"currency_type": "ALL",
		"index": 21.89,
		"rent_index": 9.3,
		"groceries_index": 26.66,
		"restaurant_index": 25.39,
		"purchasing_index": 33.2
	},
	"Cancun, Mexico": {
		"slug": "",
		"currency_type": "MXN",
		"index": 21.99,
		"rent_index": 9.77,
		"groceries_index": 27.74,
		"restaurant_index": 31.47,
		"purchasing_index": 57.4
	},
	"Monterrey, Mexico": {
		"slug": "",
		"currency_type": "MXN",
		"index": 22.25,
		"rent_index": 10.63,
		"groceries_index": 31.68,
		"restaurant_index": 28.26,
		"purchasing_index": 91.05
	},
	"Almaty, Kazakhstan": {
		"slug": "almaty",
		"currency_type": "KZT",
		"index": 23.27,
		"rent_index": 13.07,
		"groceries_index": 26.25,
		"restaurant_index": 33.78,
		"purchasing_index": 49.62
	},
	"Kathmandu, Nepal": {
		"slug": "kathmandu",
		"currency_type": "NPR",
		"index": 18.96,
		"rent_index": 4.37,
		"groceries_index": 29.26,
		"restaurant_index": 18.47,
		"purchasing_index": 24.48
	},
	"Queretaro, Mexico": {
		"slug": "",
		"currency_type": "MXN",
		"index": 20.95,
		"rent_index": 8.54,
		"groceries_index": 31.09,
		"restaurant_index": 27.79,
		"purchasing_index": 70.65
	},
	"Lahore, Pakistan": {
		"slug": "",
		"currency_type": "PKR",
		"index": 19.58,
		"rent_index": 5.77,
		"groceries_index": 27.39,
		"restaurant_index": 29.42,
		"purchasing_index": 47.35
	},
	"Davao, Philippines": {
		"slug": "",
		"currency_type": "PHP",
		"index": 19.54,
		"rent_index": 6.17,
		"groceries_index": 30.68,
		"restaurant_index": 14.26,
		"purchasing_index": 35.6
	},
	"Gurgaon, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 21.07,
		"rent_index": 9.85,
		"groceries_index": 30.12,
		"restaurant_index": 26.19,
		"purchasing_index": 110.16
	},
	"Cali, Colombia": {
		"slug": "",
		"currency_type": "COP",
		"index": 19.68,
		"rent_index": 7.48,
		"groceries_index": 25.86,
		"restaurant_index": 23,
		"purchasing_index": 36.86
	},
	"Tunis, Tunisia": {
		"slug": "tunis",
		"currency_type": "TND",
		"index": 19.53,
		"rent_index": 7.21,
		"groceries_index": 29.16,
		"restaurant_index": 20.64,
		"purchasing_index": 38.53
	},
	"Valenzuela, Philippines": {
		"slug": "",
		"currency_type": "PHP",
		"index": 17.53,
		"rent_index": 3.29,
		"groceries_index": 31.01,
		"restaurant_index": 14.83,
		"purchasing_index": 36.15
	},
	"Merida, Mexico": {
		"slug": "",
		"currency_type": "MXN",
		"index": 19.2,
		"rent_index": 7.19,
		"groceries_index": 29.42,
		"restaurant_index": 23.78,
		"purchasing_index": 36.39
	},
	"Mumbai, India": {
		"slug": "mumbai",
		"currency_type": "INR",
		"index": 26.05,
		"rent_index": 21.55,
		"groceries_index": 31.02,
		"restaurant_index": 22.23,
		"purchasing_index": 71.97
	},
	"Tijuana, Mexico": {
		"slug": "",
		"currency_type": "MXN",
		"index": 18.82,
		"rent_index": 6.97,
		"groceries_index": 27.92,
		"restaurant_index": 27.69,
		"purchasing_index": 53.57
	},
	"Guadalajara, Mexico": {
		"slug": "guadalajara",
		"currency_type": "MXN",
		"index": 18.6,
		"rent_index": 6.88,
		"groceries_index": 28.88,
		"restaurant_index": 26.78,
		"purchasing_index": 50.43
	},
	"Delhi, India": {
		"slug": "delhi",
		"currency_type": "INR",
		"index": 19.86,
		"rent_index": 9.72,
		"groceries_index": 27.84,
		"restaurant_index": 21.82,
		"purchasing_index": 77.84
	},
	"Ludhiana, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 17.12,
		"rent_index": 4.12,
		"groceries_index": 27.16,
		"restaurant_index": 21.5,
		"purchasing_index": 61.2
	},
	"Chisinau, Moldova": {
		"slug": "chisinau",
		"currency_type": "MDL",
		"index": 19.11,
		"rent_index": 8.52,
		"groceries_index": 22.62,
		"restaurant_index": 20.54,
		"purchasing_index": 29.52
	},
	"Karachi, Pakistan": {
		"slug": "",
		"currency_type": "PKR",
		"index": 18.15,
		"rent_index": 6.8,
		"groceries_index": 26.85,
		"restaurant_index": 21.37,
		"purchasing_index": 43.21
	},
	"Baku, Azerbaijan": {
		"slug": "baku",
		"currency_type": "AZN",
		"index": 20.15,
		"rent_index": 10.97,
		"groceries_index": 23.98,
		"restaurant_index": 30.13,
		"purchasing_index": 30.62
	},
	"Odesa, Ukraine": {
		"slug": "",
		"currency_type": "UAH",
		"index": 19.1,
		"rent_index": 9.03,
		"groceries_index": 19.22,
		"restaurant_index": 26.29,
		"purchasing_index": 30.13
	},
	"Noida, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 17.93,
		"rent_index": 6.64,
		"groceries_index": 28.77,
		"restaurant_index": 20.3,
		"purchasing_index": 88.2
	},
	"Thane, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 18.82,
		"rent_index": 8.54,
		"groceries_index": 28.98,
		"restaurant_index": 19.06,
		"purchasing_index": 57.1
	},
	"Tbilisi, Georgia": {
		"slug": "tbilisi",
		"currency_type": "GEL",
		"index": 18.86,
		"rent_index": 8.94,
		"groceries_index": 22.63,
		"restaurant_index": 26.86,
		"purchasing_index": 32.22
	},
	"Kiev, Ukraine": {
		"slug": "kiev",
		"currency_type": "UAH",
		"index": 20.27,
		"rent_index": 12.18,
		"groceries_index": 20.86,
		"restaurant_index": 22.16,
		"purchasing_index": 29.9
	},
	"Pune, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 17.68,
		"rent_index": 7.33,
		"groceries_index": 28.4,
		"restaurant_index": 19.46,
		"purchasing_index": 103.45
	},
	"Bangalore, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 18.26,
		"rent_index": 8.69,
		"groceries_index": 28.37,
		"restaurant_index": 16.36,
		"purchasing_index": 96.06
	},
	"Chennai, India": {
		"slug": "chennai",
		"currency_type": "INR",
		"index": 17.42,
		"rent_index": 7.15,
		"groceries_index": 29.14,
		"restaurant_index": 15.63,
		"purchasing_index": 79.47
	},
	"Kolkata, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 16.97,
		"rent_index": 6.58,
		"groceries_index": 26.49,
		"restaurant_index": 20.99,
		"purchasing_index": 57.86
	},
	"Chandigarh, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 16.63,
		"rent_index": 6.42,
		"groceries_index": 26.11,
		"restaurant_index": 18.27,
		"purchasing_index": 72.44
	},
	"Navi Mumbai, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 17.87,
		"rent_index": 9,
		"groceries_index": 25.91,
		"restaurant_index": 20.15,
		"purchasing_index": 84.65
	},
	"Kharkiv, Ukraine": {
		"slug": "",
		"currency_type": "UAH",
		"index": 18.62,
		"rent_index": 10.58,
		"groceries_index": 18.63,
		"restaurant_index": 19.53,
		"purchasing_index": 23.63
	},
	"Goa, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 17.17,
		"rent_index": 7.58,
		"groceries_index": 26.07,
		"restaurant_index": 20.06,
		"purchasing_index": 56.75
	},
	"Ahmedabad, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 16.36,
		"rent_index": 5.92,
		"groceries_index": 27.28,
		"restaurant_index": 16.73,
		"purchasing_index": 61.66
	},
	"Surat, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 15.72,
		"rent_index": 4.6,
		"groceries_index": 25.39,
		"restaurant_index": 20.12,
		"purchasing_index": 58.05
	},
	"Lucknow (Lakhnau), India": {
		"slug": "",
		"currency_type": "INR",
		"index": 15.7,
		"rent_index": 4.61,
		"groceries_index": 26.19,
		"restaurant_index": 16.32,
		"purchasing_index": 58.37
	},
	"Vadodara, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 15.29,
		"rent_index": 4.05,
		"groceries_index": 28.05,
		"restaurant_index": 16.42,
		"purchasing_index": 76.12
	},
	"Jaipur, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 15.37,
		"rent_index": 4.44,
		"groceries_index": 26.07,
		"restaurant_index": 15.54,
		"purchasing_index": 74.41
	},
	"Dnipropetrovsk, Ukraine": {
		"slug": "",
		"currency_type": "UAH",
		"index": 16.38,
		"rent_index": 6.73,
		"groceries_index": 19.11,
		"restaurant_index": 20.55,
		"purchasing_index": 34.47
	},
	"Sumy, Ukraine": {
		"slug": "",
		"currency_type": "UAH",
		"index": 14.9,
		"rent_index": 4.15,
		"groceries_index": 20.54,
		"restaurant_index": 15.48,
		"purchasing_index": 24.76
	},
	"Indore, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 14.66,
		"rent_index": 3.98,
		"groceries_index": 23.32,
		"restaurant_index": 17.18,
		"purchasing_index": 46.25
	},
	"Lviv, Ukraine": {
		"slug": "lviv",
		"currency_type": "UAH",
		"index": 16.51,
		"rent_index": 8.06,
		"groceries_index": 20,
		"restaurant_index": 15.19,
		"purchasing_index": 24.38
	},
	"Hyderabad, India": {
		"slug": "hyderabad",
		"currency_type": "INR",
		"index": 15.31,
		"rent_index": 5.8,
		"groceries_index": 25.13,
		"restaurant_index": 14.27,
		"purchasing_index": 74.08
	},
	"Kochi, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 14.96,
		"rent_index": 5.48,
		"groceries_index": 25.52,
		"restaurant_index": 13.25,
		"purchasing_index": 68.57
	},
	"Visakhapatnam, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 14.89,
		"rent_index": 5.37,
		"groceries_index": 25.23,
		"restaurant_index": 13.73,
		"purchasing_index": 62.48
	},
	"Nagpur, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 14.63,
		"rent_index": 4.91,
		"groceries_index": 23.6,
		"restaurant_index": 17.89,
		"purchasing_index": 76.12
	},
	"Coimbatore, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 14.92,
		"rent_index": 5.64,
		"groceries_index": 23.9,
		"restaurant_index": 14.98,
		"purchasing_index": 51.61
	},
	"Bhubaneswar, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 14.22,
		"rent_index": 4.21,
		"groceries_index": 24.95,
		"restaurant_index": 13.37,
		"purchasing_index": 59.77
	},
	"Cairo, Egypt": {
		"slug": "cairo",
		"currency_type": "EGP",
		"index": 14.34,
		"rent_index": 5.2,
		"groceries_index": 19.06,
		"restaurant_index": 19.16,
		"purchasing_index": 28.1
	},
	"Mangalore, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 14.04,
		"rent_index": 5.47,
		"groceries_index": 21.86,
		"restaurant_index": 11.85,
		"purchasing_index": 106.45
	},
	"Thiruvananthapuram, India": {
		"slug": "",
		"currency_type": "INR",
		"index": 12.76,
		"rent_index": 4.99,
		"groceries_index": 20.9,
		"restaurant_index": 11.36,
		"purchasing_index": 84.83
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/cost_of_living_indices.json
// module id = 15
// module chunks = 0